<template>
  <div>
    <div>
      <CustomLoader v-if="isLoading" :width="70" />
    </div>
   
    <b-card class="mainCardBG">
      <b-card-text>
        <b-navbar
          class="formCard"
          style="border-radius: 5px !important; padding-left: 0px"
          toggleable="lg"
          type="dark"
          variant="primary"
        >
          <b-navbar-nav>
            <b-button @click="previousQuotation" size="sm" variant="light">
              <md-icon icon="gear-fill" aria-hidden="true">skip_previous</md-icon>Back
            </b-button>
          </b-navbar-nav>
          <b-navbar-brand center>Goods Receipt Form</b-navbar-brand>
          <b-navbar-nav class="ml-auto"></b-navbar-nav>
        </b-navbar>
        <banner-component
          :allModuleIdBanner="
            this.vehicleBooking.allModuleId ? this.vehicleBooking.allModuleId : ''
          "
          :jobSeriesBanner="
            this.vehicleBooking.bookingNo ? this.vehicleBooking.bookingNo : ''
          "
          :bannerClientName="
            this.vehicleBooking.shipperCustomerName
              ? this.vehicleBooking.shipperCustomerName
              : ''
          "
          iconId="fa fa-ship"
        />
        <div>
          <b-alert
            style="
              background-color: red !important;
              padding: 0.45rem 1rem !important;
              margin-bottom: 3px !important;
            "
            id="1"
            variant="danger"
            show
            v-if="
              vehicleBooking.noOfTrucks != showGRNList.length &&
              goodReceived.goodReceivedID == ''
            "
          >
            Please Enter {{ pendingGrn }} Vehicle Details to Proceed Further..!
          </b-alert>

          <b-alert
            style="
              background-color: #002b4954 !important;
              padding: 0.45rem 1rem !important;
              margin-bottom: 3px !important;
            "
            id="1"
            variant="success"
            show
            v-if="
              vehicleBooking.noOfTrucks == showGRNList.length &&
              goodReceived.goodReceivedID == ''
            "
          >
            <span> All Vehicle Details Added Successfully.You can Proceed Further </span>
          </b-alert>
        </div>
        <b-card class="formCard">
          <b-card-text>
            <div
              v-if="
                vehicleBooking.noOfTrucks != showGRNList.length ||
                goodReceived.goodReceivedID != ''
              "
            >
              <md-layout md-gutter>
                <md-layout md-flex="25" md-flex-small="100" class="pl-2 pr-2">
                  <label for="ccType">Transportation By *</label>
                  <model-list-select
                    :isDisabled="goodReceived.goodReceivedID != '' && $sessionsStorage.get('nameUser') != 'Bhavneesh' ? true : false"
                    @input="changeDataOnTPTType"
                    :list="TPTtypeList"
                    v-model="goodReceived.tptType"
                    option-value="ccTypeVal"
                    option-text="ccTypeTxt"
                    placeholder="Select Transport Type"
                  ></model-list-select>
                  <span class="error" v-if="!goodReceived.tptType">
                    {{ tptTypeError }}
                  </span>
                </md-layout>
                <md-layout md-flex="25" class="pl-2 pr-2">
                  <label for="AutoContainerType">Skip GRN</label>
                  <model-list-select
                    :isDisabled="(goodReceived.tptType == '3') ?true: (goodReceived.goodReceivedID != '' && $sessionsStorage.get('nameUser') != 'Bhavneesh' ? true : false)"
                    @input="clearFuelSlip"
                    :list="skipGRNList"
                    v-model="goodReceived.skipGRN"
                    option-value="val"
                    option-text="text"
                    placeholder="Select "
                  ></model-list-select>
                </md-layout>
                <md-layout md-flex="25" class="pl-2 pr-2">
                  <label for="AutoContainerType">Movement Type *</label>
                  <model-list-select
                    :isDisabled="
                      goodReceived.goodReceivedID != '' &&
                      $sessionsStorage.get('nameUser') != 'Bhavneesh'
                        ? true
                        : false
                    "
                    :list="movementTypeList"
                    v-model="goodReceived.movementType"
                    option-value="val"
                    option-text="text"
                    placeholder="Select "
                  ></model-list-select>
                  <span class="error" v-if="!goodReceived.movementType">
                    {{ movementTypeError }}
                  </span>
                </md-layout>
                <md-layout
                  md-flex="25"
                  class="pl-2 pr-2"
                  v-if="goodReceived.skipGRN != '1'"
                >
                  <label>GRN Date</label>
                  <date-picker
                    v-if="
                      $sessionsStorage.get('designation') == 'Admin' &&
                      $sessionsStorage.get('nameUser') == 'Bhavneesh'
                    "
                    :disabled="
                      goodReceived.goodReceivedID != '' &&
                      $sessionsStorage.get('nameUser') != 'Bhavneesh'
                        ? true
                        : false
                    "
                    :format="selectDateFormat"
                    lang="en"
                    width="100%"
                    v-model="goodReceived.Date"
                    type="date"
                    id="Date"
                    placeholder="GRN Date"
                  ></date-picker>
                  <span class="error" v-if="!goodReceived.Date">
                    {{ DateError }}
                  </span>
                </md-layout>
                <md-layout
                  md-flex="50"
                  class="pl-2 pr-2"
                  v-if="goodReceived.tptType == '1' || goodReceived.tptType == '3'"
                >
                  <label for="refuelData">Re-Fueling Station Name *</label>

                  <model-list-select
                    :isDisabled="
                      goodReceived.goodReceivedID != '' &&
                      $sessionsStorage.get('nameUser') != 'Bhavneesh'
                        ? true
                        : false
                    "
                    :list="refuelStationArrList"
                    v-model="refuelData"
                    option-value="refuelStationId"
                    option-text="vendorName"
                    placeholder="Select Refuel  Station"
                  ></model-list-select>

                  <span class="error" v-if="!goodReceived.reFuelstation">
                    {{ reFuelstationError }}
                  </span>
                </md-layout>
                <md-layout
                  md-flex="50"
                  class="pl-2 pr-2"
                  v-if="(goodReceived.tptType == '2' || goodReceived.tptType == '3') && goodReceived.skipGRN == '1'"
                >
                  <md-layout md-flex="100">
                    <label>Outsource GRN No. *</label>
                    <b-form-input
                      :Disabled="
                        goodReceived.goodReceivedID != '' &&
                        $sessionsStorage.get('nameUser') != 'Bhavneesh'
                          ? true
                          : false
                      "
                      :formatter="capitalizeAll"
                      name="Date"
                      id="Date"
                      v-model="goodReceived.outSourceGRNo"
                    ></b-form-input>
                  </md-layout>
                  <span class="error" v-if="!goodReceived.outSourceGRNo">
                    {{ outGrNoError }}
                  </span>
                </md-layout>
                <md-layout
                  md-flex="50"
                  class="pl-2 pr-2"
                  v-if="goodReceived.tptType == '1' || goodReceived.tptType == '3'"
                >
                  <md-layout md-flex="100">
                    <label>Re-Fueling Station Address</label>

                    <b-form-textarea
                      :Disabled="
                        goodReceived.goodReceivedID != '' &&
                        $sessionsStorage.get('nameUser') != 'Bhavneesh'
                          ? true
                          : false
                      "
                      :formatter="capitalizeAll"
                      style="height: 40px"
                      name="refuelAddress"
                      id="refuelAddress"
                      v-model="goodReceived.refuelAddress"
                    ></b-form-textarea>
                  </md-layout>
                </md-layout>
                <md-layout
                  md-flex="25"
                  class="pl-2 pr-2"
                  v-if="(goodReceived.tptType == '2' || goodReceived.tptType == '3') && goodReceived.skipGRN == '1'"
                >
                  <label>Outsource GRN Date *</label>
                  <date-picker
                    :Disabled="
                      goodReceived.goodReceivedID != '' &&
                      $sessionsStorage.get('nameUser') != 'Bhavneesh'
                        ? true
                        : false
                    "
                    width="100%"
                    :format="selectDateFormat"
                    lang="en"
                    id="pickupDate"
                    :minute-step="1"
                    name="pickupDate"
                    v-model="goodReceived.outSourceGRNDate"
                  ></date-picker>
                  <span class="error" v-if="!goodReceived.outSourceGRNDate">
                    {{ outSourceGRNDateError }}
                  </span>
                </md-layout>
                <md-layout md-flex="25" v-if="(goodReceived.tptType == '2')">
                  <md-layout md-flex="100" class="pl-2 pr-2">
                    <label>Outsource Vehicle No. *</label>
                    <b-form-input
                      :Disabled="
                        goodReceived.goodReceivedID != '' &&
                        $sessionsStorage.get('nameUser') != 'Bhavneesh'
                          ? true
                          : false
                      "
                      :formatter="capitalizeAll"
                      name="refuelAddress"
                      id="refuelAddress"
                      v-model="goodReceived.outSourceVehicleNo"
                    ></b-form-input>
                  </md-layout>
                  <span class="error" v-if="!goodReceived.outSourceVehicleNo">
                    {{ outSourceVehicleNoError }}
                  </span>
                </md-layout>
              </md-layout>

              <md-layout md-gutter v-if="goodReceived.tptType == '1' || goodReceived.tptType == '3'">
                <md-layout md-flex="25" class="pl-2 pr-2">
                  <md-layout md-flex="100">
                    <label>Advance Cash (Quotation)</label>
                    <b-form-input
                      :formatter="capitalizeAll"
                      :disabled="
                        goodReceived.goodReceivedID != '' &&
                        $sessionsStorage.get('nameUser') != 'Bhavneesh'
                          ? true
                          : false
                      "
                      name="advanceCash"
                      id="advanceCash"
                      v-model="goodReceived.advanceCash"
                    ></b-form-input>
                  </md-layout>
                </md-layout>

                <md-layout md-flex="25" class="pl-2 pr-2">
                  <md-layout md-flex="100">
                    <label>Actual cash Dispensed *</label>
                    <b-form-input
                      :Disabled="
                        goodReceived.goodReceivedID != '' &&
                        $sessionsStorage.get('nameUser') != 'Bhavneesh'
                          ? true
                          : false
                      "
                      :formatter="capitalizeAll"
                      type="number"
                      min="0"
                      name="otherCashExpenses"
                      id="otherCashExpenses"
                      v-model="goodReceived.otherCashExpenses"
                      @keyup="finalActivityCost"
                    ></b-form-input>
                  </md-layout>
                  <span class="error" v-if="!goodReceived.otherCashExpenses">
                    {{ otherCashExpensesError }}
                  </span>
                </md-layout>
                <md-layout md-flex="25" class="pl-2 pr-2">
                  <md-layout md-flex="100">
                    <label>Diesel (in Ltr.)</label>

                    <b-form-input
                      :formatter="capitalizeAll"
                      :disabled="
                        goodReceived.goodReceivedID != '' &&
                        $sessionsStorage.get('nameUser') != 'Bhavneesh'
                          ? true
                          : false
                      "
                      type="number"
                      min="0"
                      name="diesel"
                      id="diesel"
                      v-model="goodReceived.diesel"
                      @keyup="finalActivityCost"
                    ></b-form-input>
                  </md-layout>
                </md-layout>

                <md-layout md-flex="25" class="pl-2 pr-2">
                  <md-layout md-flex="100">
                    <label>Actual Diesel Dispensed *</label>
                    <b-form-input
                      :Disabled="
                        goodReceived.goodReceivedID != '' &&
                        $sessionsStorage.get('nameUser') != 'Bhavneesh'
                          ? true
                          : false
                      "
                      :formatter="capitalizeAll"
                      type="number"
                      min="0"
                      name="dieselPrice"
                      id="dieselPrice"
                      v-model="goodReceived.dieselPrice"
                      @keyup="finalActivityCost"
                    ></b-form-input>
                  </md-layout>
                  <span class="error" v-if="!goodReceived.dieselPrice">
                    {{ dieselPriceError }}
                  </span>
                </md-layout>
                <md-layout md-flex="25" class="pl-2 pr-2">
                  <md-layout md-flex="100">
                    <label>Toll in cash *</label>
                    <b-form-input
                      :Disabled="
                        goodReceived.goodReceivedID != '' &&
                        $sessionsStorage.get('nameUser') != 'Bhavneesh'
                          ? true
                          : false
                      "
                      :formatter="capitalizeAll"
                      type="number"
                      min="0"
                      name="tollInCash"
                      id="tollInCash"
                      v-model="goodReceived.tollInCash"
                      @keyup="finalActivityCost"
                    ></b-form-input>
                  </md-layout>
                  <span class="error" v-if="!goodReceived.tollInCash">
                    {{ tollInCashError }}
                  </span>
                </md-layout>

                <md-layout md-flex="25" class="pl-2 pr-2">
                  <md-layout md-flex="100">
                    <label>Amount Paid in Cash for Diesel *</label>
                    <b-form-input
                      :Disabled="
                        goodReceived.goodReceivedID != '' &&
                        $sessionsStorage.get('nameUser') != 'Bhavneesh'
                          ? true
                          : false
                      "
                      :formatter="capitalizeAll"
                      type="number"
                      min="0"
                      name="cashDeiselPaid"
                      id="cashDeiselPaid"
                      v-model="goodReceived.cashDeiselPaid"
                      @keyup="finalActivityCost"
                    ></b-form-input>
                  </md-layout>
                  <span class="error" v-if="!goodReceived.cashDeiselPaid">
                    {{ cashDeiselPaidError }}
                  </span>
                </md-layout>

              </md-layout>
              <div v-if="goodReceived.tptType == '1' || goodReceived.tptType == '3'">
               

                <md-layout md-gutter>
                  <md-layout
                    md-flex="25"
                    class="pl-2"
                    v-if="goodReceived.goodReceivedID != ''"
                  >
                    <md-layout md-flex="100">
                      <label>Booked Vehicle</label>
                      <b-form-input
                        :formatter="capitalizeAll"
                        name="regdNo"
                        id="regdNo"
                        v-model="goodReceived.regdNo"
                        :disabled="
                          goodReceived.goodReceivedID != '' &&
                          $sessionsStorage.get('nameUser') != 'Bhavneesh'
                            ? true
                            : false
                        "
                      ></b-form-input>
                    </md-layout>
                  </md-layout>
                  <md-layout md-flex="25" class="pr-2">
                    <label for="status">
                      {{ goodReceived.goodReceivedID != "" ? "Change" : "" }}
                      Vehicle No. *
                    </label>
                    <model-list-select
                      :list="grnVehicleList"
                      v-model="goodReceived.vehicleTruckId"
                      option-value="vehicleTruckId"
                      option-text="regdNo"
                      placeholder="Select Vehicle "
                      @input="fetchDriverFromVehicle"
                    ></model-list-select>

                    <span class="error" v-if="!goodReceived.vehicleTruckId">
                      {{ vehicleTruckIdError }}
                    </span>
                  </md-layout>
                  <md-layout
                    md-flex="25"
                    class="pl-2"
                    v-if="goodReceived.goodReceivedID != ''"
                  >
                    <md-layout md-flex="100">
                      <div class="d-flex justify-content-between align-items-center mb-2">
                        <label class="mb-0">Booked Driver</label>
                      </div>
                      <b-form-input
                        :formatter="capitalizeAll"
                        name="regdNo"
                        id="regdNo"
                        v-model="goodReceived.driverName"
                        :disabled="
                          goodReceived.goodReceivedID != '' &&
                          $sessionsStorage.get('nameUser') != 'Bhavneesh'
                            ? true
                            : false
                        "
                      ></b-form-input>
                    </md-layout>
                  </md-layout>

                  <md-layout md-flex="25" class="pr-2">
                    <md-layout md-flex="100">
                      <div class="d-flex justify-content-between align-items-center mb-2">
                        <label for="assignDriverId" class="mb-0">Driver Name</label>
                        <b-button
                          variant="outline-primary"
                          @click="openDriverModal()"
                          size="sm"
                          class="ml-2">
                          <md-icon>add</md-icon>Add Driver
                        </b-button>
                      </div>

                      <model-list-select
                        :list="assignedDriverAll"
                        v-model="goodReceived.driverId"
                        option-value="driverId"
                        option-text="driverName"
                        placeholder="Select Driver"
                        :isDisabled="
                          goodReceived.goodReceivedID != '' &&
                          $sessionsStorage.get('nameUser') != 'Bhavneesh'
                            ? true
                            : false
                        "
                      ></model-list-select>
                    </md-layout>
                  </md-layout>

                  <md-layout md-flex="70"></md-layout>

                  <md-layout md-flex="30" v-if="checkCargo == true">
                    <div class="d-flex justify-content-between align-items-center mb-2">
                      <label for="assignDriverId" class="mb-0">Assigned Driver Name </label>
                    </div>

                    <model-list-select
                      :list="assignedDriverAll"
                      v-model="goodReceived.assignDriverId"
                      option-value="driverId"
                      option-text="driverName"
                      placeholder="Select Driver"
                    ></model-list-select>

                    <span class="error" v-if="!goodReceived.assignDriverId">
                      {{ assignDriverIdError }}
                    </span>
                  </md-layout>
                </md-layout>

                <md-layout
                  md-gutter
                  class="gutr"
                  v-if="goodReceived.goodReceivedID == ''"
                >
                  <md-layout md-flex="30"></md-layout>

                  <md-layout md-flex="25" v-if="goodReceived.driverId != ''">
                    <md-checkbox
                      style="margin-top: -6px"
                      id="my-test9"
                      name="my-test9"
                      v-model="checkCargo"
                      class="md-primary"
                      @change="showMultipleCargo"
                      >Assign New Driver</md-checkbox
                    >
                  </md-layout>
                </md-layout>
                <md-layout md-gutter  v-if="goodReceived.tptType == '3'">
                  <md-layout md-flex="100" class="pl-2 pr-2">
                    <md-layout md-flex="100">
                      <label>Transporter Name *</label>
                      <b-form-input
                        :Disabled="
                          goodReceived.goodReceivedID != '' &&
                          $sessionsStorage.get('nameUser') != 'Bhavneesh'
                            ? true
                            : false
                        "
                        :formatter="capitalizeAll"
                        name="refuelAddress"
                        id="refuelAddress"
                        v-model="goodReceived.transporterName"
                      ></b-form-input>
                    </md-layout>
                    <span class="error" v-if="!goodReceived.transporterName">
                      {{ transporterNameError }}
                    </span>
                  </md-layout>
                </md-layout>
              </div>
              <div v-else>
                <md-layout md-gutter>
                  <md-layout md-flex="100" class="pl-2 pr-2">
                    <md-layout md-flex="100">
                      <label>Transporter Name *</label>
                      <b-form-input
                        :Disabled="
                          goodReceived.goodReceivedID != '' &&
                          $sessionsStorage.get('nameUser') != 'Bhavneesh'
                            ? true
                            : false
                        "
                        :formatter="capitalizeAll"
                        name="refuelAddress"
                        id="refuelAddress"
                        v-model="goodReceived.transporterName"
                      ></b-form-input>
                    </md-layout>
                    <span class="error" v-if="!goodReceived.transporterName">
                      {{ transporterNameError }}
                    </span>
                  </md-layout>
                </md-layout>
              </div>
              <md-layout md-gutter>
                <md-layout md-flex="50" class="pl-2 pr-2">
                  <label for="AutoContainerType">Container Size-Type *</label>
                  <model-list-select
                    :isDisabled="
                      goodReceived.goodReceivedID != '' &&
                      $sessionsStorage.get('nameUser') != 'Bhavneesh'
                        ? true
                        : false
                    "
                    @input="masterCallbackContainer"
                    :list="containerList"
                    v-model="AutoContainerType"
                    option-value="containerTypeId"
                    option-text="containerType"
                    placeholder="Select Container"
                  ></model-list-select>
                  <span
                    class="error"
                    v-if="goodReceived.multipleContainerType.length == 0"
                    >{{ ContainerSizeError }}</span
                  >
                </md-layout>
                <md-layout md-flex="50" class="pl-2 pr-2">
                  <md-layout md-flex="100">
                    <label>Container No. (AAAA1234567) *</label>
                   
                    <b-form-radio-group v-model="goodReceived.cont_input_type" :options="contTypeList" class="mb-3"
                      value-field="Val" text-field="Text" @input="getContainerText()" disabled-field="notEnabled" :disabled="(goodReceived.goodReceivedID != '')?true:false"></b-form-radio-group>
                      
                    <b-form-input
                      :formatter="capitalizeAll"
                      :disabled="
                        (goodReceived.goodReceivedID != '' &&
                          $sessionsStorage.get('designation') != 'Admin' &&
                          $sessionsStorage.get('nameUser') != 'Bhavneesh') ||
                        (goodReceived.shipmentType == '1' &&
                          goodReceived.NewContainerTypeId.indexOf('15') >= 0 &&
                          goodReceived.transportType == 'Export' &&
                          goodReceived.containerInfo == 'lcl' &&
                          $sessionsStorage.get('designation') != 'Admin') ||
                          (goodReceived.cont_input_type!=='Container')
                          ? true
                          : false
                      "
                      v-model="goodReceived.containerNo"
                      name="containerNo"
                      id="containerNo"
                      @keyup="containerNoRegexfun()"
                    ></b-form-input>
                    <b
                      v-if="checkContNoButton == 3 || checkContNoButton == 2"
                      :class="checkContNoButton == 1 ? 'success' : 'error'"
                    >
                      {{ timmerMsg }}
                    </b>
                  </md-layout>
                  <span class="error" v-if="!goodReceived.containerNo">
                    {{ containerNoError }}
                  </span>
                  <span class="error" v-else-if="containerNoRegexError != ''">
                    {{ containerNoRegexError }}
                  </span>
                  <span
                    class="error"
                    v-if="
                      containerNoRegexError == '' &&
                      goodReceived.containerNo != '' &&
                      goodReceived.containerNo != algoConNo &&
                      showAlgo == true
                    "
                  >
                    Note:System Generated Container No. is :
                    {{ algoConNo }}
                  </span>
                </md-layout>

                <md-layout
                  md-flex="10"
                  v-if="
                    containerNoRegexError == '' &&
                    goodReceived.containerNo != '' &&
                    goodReceived.multipleContainerType.length > 1 &&
                    totalCon == ''
                  "
                  style="margin-top: 35px"
                >
                  <b-button
                    v-if="goodReceived.goodReceivedID == ''"
                    variant="outline-dark"
                    @click="shiftContainer"
                    size="sm"
                    >Add Another</b-button
                  >
                </md-layout>
                <md-layout md-flex="15" class="pl-2 pr-2" v-if="totalCon != ''">
                  <md-layout md-flex="100">
                    <label>Second Container No.</label>
                    <b-form-input
                      :formatter="capitalizeAll"
                      disabled
                      v-model="totalCon"
                      name="containerNo"
                      id="containerNo"
                    ></b-form-input>
                  </md-layout>
                </md-layout>
                <md-layout md-flex="5">
                  <b-button
                    v-if="totalCon != ''"
                    style="margin-top: 35px"
                    variant="info"
                    @click="clear2Con"
                    size="sm"
                    >Clear</b-button
                  >
                </md-layout>
              </md-layout>
              <md-layout md-gutter v-if="goodReceived.multipleContainerType.length > 0">
                <md-layout md-flex="40" class="pl-2 pr-2 mt-2">
                  <md-chip
                    md-deletable
                    :disabled="goodReceived.goodReceivedID == '' ? false : true"
                    v-for="(type, index) in goodReceived.multipleContainerType"
                    :key="index"
                    @delete="deleteContainer(type, index)"
                    >{{ type }}</md-chip
                  >
                </md-layout>
              </md-layout>
              <md-layout md-gutter>
                <md-layout md-flex="25" class="pr-2">
                  <label for="status">Vehicle Type. *</label>
                  <model-list-select
                    :isDisabled="
                      goodReceived.goodReceivedID &&
                      $sessionsStorage.get('designation') != 'Admin' &&
                      $sessionsStorage.get('nameUser') != 'Bhavneesh'
                        ? true
                        : false
                    "
                    :list="grnVehicleList"
                    v-model="goodReceived.vehicleType"
                    option-value="vehicleType"
                    option-text="vehicleType"
                    placeholder="Select Vehicle Type"
                  ></model-list-select>

                  <span class="error" v-if="!goodReceived.vehicleType">
                    {{ vehicleTypeError }}
                  </span>
                </md-layout>
                <md-layout md-flex="75" class="pr-2">
                  <label for="status">Description.</label>
                  <b-form-textarea
                    :state="goodReceived.Description.length >= 30"
                    :maxlength="
                      $sessionsStorage.get('designation') != 'Admin' &&
                      $sessionsStorage.get('nameUser') != 'Bhavneesh'
                        ? '90'
                        : ''
                    "
                    :formatter="capitalizeAll"
                    name="consignorAddress"
                    id="consignorAddress"
                    v-model="goodReceived.Description"
                    placeholder="Please Enter Description"
                    rows="1"
                    max-rows="1"
                    no-resize
                  ></b-form-textarea>

                  <span class="error" v-if="!goodReceived.Description">
                    {{ DescriptionError }}
                  </span>
                </md-layout>
                <md-layout
                  md-flex="25"
                  class="pr-2"
                  v-if="
                    $sessionsStorage.get('designation') == 'Admin' &&
                    $sessionsStorage.get('nameUser') == 'Bhavneesh'
                  "
                >
                  <label for="status">Consignee.</label>
                  <b-form-textarea
                    :formatter="capitalizeAll"
                    name="consignorAddress"
                    id="consignorAddress"
                    v-model="goodReceived.consignee"
                    placeholder="Please Enter Consignee Details"
                  ></b-form-textarea>
                </md-layout>
                <md-layout
                  md-flex="25"
                  class="pr-2"
                  v-if="
                    $sessionsStorage.get('designation') == 'Admin' &&
                    $sessionsStorage.get('nameUser') == 'Bhavneesh'
                  "
                >
                  <label for="status">Consignor.</label>
                  <b-form-textarea
                    :formatter="capitalizeAll"
                    name="consignor"
                    id="consignor"
                    v-model="goodReceived.consignor"
                    placeholder="Please Enter Consignor Details"
                  ></b-form-textarea>
                </md-layout>
                <md-layout
                  md-flex="25"
                  class="pr-2"
                  v-if="
                    $sessionsStorage.get('designation') == 'Admin' &&
                    $sessionsStorage.get('nameUser') == 'Bhavneesh'
                  "
                >
                  <label for="status">G. Wt.</label>
                  <b-form-input
                    :formatter="capitalizeAll"
                    v-model="goodReceived.weight"
                    name="containerNo"
                    id="containerNo"
                  ></b-form-input>
                </md-layout>
                <md-layout
                  md-flex="25"
                  class="pr-2"
                  v-if="
                    $sessionsStorage.get('designation') == 'Admin' &&
                    $sessionsStorage.get('nameUser') == 'Bhavneesh'
                  "
                >
                  <label for="status">Remark.</label>
                  <b-form-textarea
                    :formatter="capitalizeAll"
                    name="consignorAddress"
                    id="consignorAddress"
                    v-model="goodReceived.weight_remark"
                    placeholder="Please Enter Remark Details"
                  ></b-form-textarea>
                </md-layout>
              </md-layout>
              <md-layout
                md-gutter
                v-if="
                  (goodReceived.containerInfo == 'fcl' ||
                    goodReceived.containerInfo == '') &&
                  goodReceived.NewContainerTypeId.indexOf('15') < 0
                "
              >
                <md-layout md-flex="25" class="pl-2 pr-2">
                  <label for="slineName">Shipping-Line Name *</label>

                  <model-list-select
                    :isDisabled="
                      goodReceived.goodReceivedID != '' &&
                      $sessionsStorage.get('designation') != 'Admin' &&
                      $sessionsStorage.get('nameUser') != 'Bhavneesh'
                        ? true
                        : false
                    "
                    :list="ShippingList"
                    v-model="goodReceived.slineName"
                    option-value="shippingId"
                    option-text="shippingLine"
                    placeholder="Select Shipping Line"
                  ></model-list-select>

                  <span class="error" v-if="!goodReceived.slineName">
                    {{ slineNameError }}
                  </span>
                </md-layout>

                <md-layout md-flex="25" class="pl-2 pr-2">
                  <md-layout md-flex="100">
                    <label>S-Line Seal Number *</label>
                    <b-form-input
                      :Disabled="
                        goodReceived.goodReceivedID != '' &&
                        $sessionsStorage.get('designation') != 'Admin' &&
                        $sessionsStorage.get('nameUser') != 'Bhavneesh'
                          ? true
                          : false
                      "
                      :formatter="capitalizeAll"
                      name="slineSealNo"
                      id="slineSealNo"
                      v-model="goodReceived.slineSealNo"
                    ></b-form-input>
                  </md-layout>
                  <span class="error" v-if="!goodReceived.slineSealNo">
                    {{ slineSealNoError }}
                  </span>
                </md-layout>

                <md-layout md-flex="25" class="pl-2 pr-2">
                  <md-layout md-flex="100">
                    <label>Custom Seal No.</label>
                    <b-form-input
                      :Disabled="
                        goodReceived.goodReceivedID != '' &&
                        $sessionsStorage.get('nameUser') != 'Bhavneesh'
                          ? true
                          : false
                      "
                      :formatter="capitalizeAll"
                      name="customClearenceNo"
                      id="customClearenceNo"
                      v-model="goodReceived.customSealNo"
                    ></b-form-input>
                  </md-layout>
                </md-layout>
              </md-layout>
              <md-layout md-gutter>
                <md-layout md-flex="25" class="pl-2 pr-2">
                  <label>Arrival at Factory</label>
                  <date-picker
                    width="100%"
                    lang="en"
                    :format="selectDateFormat"
                    v-model="goodReceived.factoryInDate"
                    type="datetime"
                    id="factoryDate"
                    :disabled="
                      goodReceived.goodReceivedID != '' &&
                      $sessionsStorage.get('nameUser') != 'Bhavneesh'
                        ? true
                        : false
                    "
                  ></date-picker>
                  <span class="error" v-if="!goodReceived.factoryInDate">
                    {{ factoryInDateError }}
                  </span>
                </md-layout>

                <md-layout md-flex="25" class="pl-2 pr-2">
                  <label>Dispatch from Factory</label>
                  <date-picker
                    :disabled="
                      goodReceived.goodReceivedID != '' &&
                      $sessionsStorage.get('nameUser') != 'Bhavneesh'
                        ? true
                        : false
                    "
                    :format="selectDateFormat"
                    lang="en"
                    width="100%"
                    v-model="goodReceived.factoryOutDate"
                    type="date"
                    id="factoryOutDate"
                  ></date-picker>
                  <span class="error" v-if="!goodReceived.factoryOutDate">
                    {{ factoryOutDateError }}
                  </span>
                </md-layout>
                <md-layout md-flex="25" class="pl-2 pr-2">
                  <md-layout md-flex="100">
                    <label>Fuel Slip No. *</label>
                    <b-form-input
                      :formatter="capitalizeAll"
                      name="FuelSlipNo"
                      id="FuelSlipNo"
                      v-model="goodReceived.FuelSlipNo"
                      :disabled="true"
                    ></b-form-input>
                  </md-layout>
                  <span class="error" v-if="!goodReceived.FuelSlipNo">
                    {{ FuelSlipNoError }}
                  </span>
                </md-layout>

                <md-layout
                  md-flex="25"
                  class="pl-2 pr-2"
                  v-if="goodReceived.goodReceivedID != ''"
                >
                  <label for="status">Vehicle Status *</label>

                  <model-list-select
                    :list="statusList"
                    v-model="goodReceived.status"
                    option-value="statusV"
                    option-text="statusT"
                    placeholder="Select Vehicle Status"
                    :isDisabled="
                      goodReceived.vehicleReleaseDateAdded == 1 &&
                      goodReceived.goodReceivedID != '' &&
                      $sessionsStorage.get('nameUser') != 'Bhavneesh'
                        ? true
                        : false
                    "
                  ></model-list-select>

                  <span class="error" v-if="!vehicleBooking.status">
                    {{ statusError }}
                  </span>
                </md-layout>
              </md-layout>
              <md-layout md-gutter class="justify-content-center mt-3">
                <md-layout md-flex="10" class="pl-2 pr-2">
                  <b-button
                    :disabled="checkContNoButton != 1 ? true : false"
                    variant="primary"
                    size="sm"
                    id="addButtonLoader11"
                    @click="generateGrnForm"
                  >
                    {{ goodReceived.goodReceivedID == "" ? "Generate" : "Generate" }}
                    GRN
                  </b-button>
                  <span class="error">{{ goodReceived.UpdateReason }}</span>
                  <md-spinner
                    md-indeterminate
                    id="loader11"
                    style="display: none"
                  ></md-spinner>
                  <span class="error mt-5 ml-2">
                    {{ containerNoRegexError }}
                  </span>
                </md-layout>
              </md-layout>
            </div>

            <div v-if="goodReceived.goodReceivedID == ''">
              <div class="box" v-if="showGRNList.length > 0">
                <div class="box-header">
                  <b-button
                    class="pull-right ml-2"
                    v-if="showGRNList.length > 0"
                    variant="outline-info"
                    size="sm"
                    @click="goToMailPage('T')"
                    >Track Assignment</b-button
                  >
                  <b-button
                    class="pull-right ml-2"
                    v-if="showGRNList.length > 0"
                    variant="outline-info"
                    size="sm"
                    @click="goToMailPage('M')"
                    >Send GRN Consolidation Mail</b-button
                  >
                </div>
                <div class="box-header">
                </div>

                <div class="table-responsive tableMain">
                  <table id="truckDetail2" class="table table-bordered">
                    <thead>
                      <tr>
                        <th>Sr No.</th>
                        <th>GRN Details</th>
                        <th>Other Details</th>
                        <th>Transportation By</th>
                        <th>Transporter Name</th>

                        <th>Vehicle Status</th>

                        <th>Action</th>
                        <th>Print</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(item, index) in showGRNList" :key="index">
                        <td>{{ index + 1 }}</td>
                        <td>
                          <b>GRN No. :</b>
                          {{ item.GRNSeries }}
                          <br />
                          <b>GRN Date :</b>
                          {{ item.Date | moment }}
                          <br />
                          <b>Vehicle No. :</b>
                          {{
                            item.regdNo != null && item.regdNo != ""
                              ? item.regdNo
                              : item.vehicleNo
                          }}
                          <br />
                          <b>Driver Name :</b>
                          {{ item.driverName }}
                          <br />
                          <b>Assigned Driver Name :</b>
                          {{
                            item.assignedDriverName != "" ? item.assignedDriverName : "NA"
                          }}
                        </td>
                        <td>
                          <b>Fuel Slip No. :</b>
                          {{ item.FuelSlipNo }}
                          <br />
                          <b>Container No. :</b>
                          {{ item.containerNo }} ({{ item.multipleContainerType }})
                          <br />
                          <b>Shipping Line Name :</b>
                          {{ item.shippingLine }}
                          <br />
                          <b>Shipping Line Seal No. :</b>
                          {{ item.slineSealNo }}
                        </td>
                        <td>{{ item.tptType == 1 ? "Pridel" :item.tptType == 3 ? "PRIDEL HIRING" : item.tptType == 2 ? "OutSourced" : "" }}</td>
                        <td>
                          {{ item.transporterName == "" ? "NA" : item.transporterName }}
                        </td>
                        <td>
                          {{
                            item.status == 1
                              ? "In Transit"
                              : "Closed (Vehicle Reached At Destination)"
                          }}
                        </td>

                        <td>
                          <b-button
                            size="sm"
                            variant="outline-info"
                            @click="showGRN(item)"
                            >Edit</b-button
                          >
                          <b-button
                            v-if="
                              $sessionsStorage.get('nameUser') == 'Bhavneesh' &&
                              $sessionsStorage.get('designation') == 'Admin'
                            "
                            size="sm"
                            variant="outline-info"
                            @click="openModalGRNNO(item)"
                            >Reset GRN No</b-button
                          >
                        </td>
                        <td>
                          <b-button
                            v-if="item.skipGRN == '0'"
                            size="sm"
                            variant="outline-success"
                            @click="Print(item.pdfGRN)"
                            >GRN PDF</b-button
                          >
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>

              <md-layout
                md-gutter
                class="mrgtop-2per justify-content-center"
                v-if="vehicleBooking.noOfTrucks == showGRNList.length"
              >
                <md-layout md-flex="20">
                  <b-button
                    variant="primary"
                    :disabled="permissionStatus"
                    @click="goodsReceived"
                    id="addButtonLoader1"
                    >Save & Proceed</b-button
                  >
                  <md-spinner
                    md-indeterminate
                    id="loader1"
                    style="display: none"
                  ></md-spinner>
                </md-layout>
              </md-layout>
            </div>
          </b-card-text>
        </b-card>
      </b-card-text>
    </b-card>

    <b-modal
      no-close-on-esc
      no-close-on-backdrop
      ref="Reset-GRNNO-modal"
      hide-footer
      id="modal-multi-2"
      size="lg"
      :title="'Reset GRNNO  : ' + UpdateGRNDetails.previousGRNNo"
    >
      <label for="validBookingNo"> GRN Count </label>

      <b-input
        type="number"
        id="grnIdNew"
        name="grnIdNew"
        v-model="UpdateGRNDetails.grnIdNew"
      ></b-input>

      <b-button size="sm" class="mt-4" variant="outline-danger" @click="hideModalGRNNO"
        >Close</b-button
      >
      <b-button
        size="sm"
        class="mt-4 ml-auto"
        variant="outline-success"
        @click="ResetGRNNO"
        >Save</b-button
      >
    </b-modal>
    <b-modal
      no-close-on-esc
      no-close-on-backdrop
      size="xl"
      ref="Driver-modal"
      hide-footer
      :title="isEditMode ? 'Edit Driver' : 'Add Driver'"
      @hidden="resetDriverModal"
    >
      <b-form @submit.prevent="addDriver">
        <!-- Basic Information -->
        <h6 class="text-primary mb-3">Basic Information</h6>
        <b-row>
          <b-col md="4">
            <label>Location <span class="error">*</span></label>
            <b-form-input
              size="sm"
              id="location"
              name="location"
              v-model="driverModal.location"
              placeholder="Enter Location"
              :state="!errorList.location"
            ></b-form-input>
            <span class="error" v-if="errorList.location">{{ errorList.location }}</span>
          </b-col>
          <b-col md="4">
            <label>Vehicle Number</label>
            <b-form-input
              size="sm"
              id="vehicleNumber"
              name="vehicleNumber"
              v-model="driverModal.vehicleNumber"
              placeholder="Enter Vehicle Number"
            ></b-form-input>
          </b-col>
          <b-col md="4">
            <label>Driver Type <span class="error">*</span></label>
            <b-form-select
              size="sm"
              id="driverType"
              name="driverType"
              v-model="driverModal.driverType"
              :options="driverTypeOptions"
              :state="!errorList.driverType"
            ></b-form-select>
            <span class="error" v-if="errorList.driverType">{{ errorList.driverType }}</span>
          </b-col>
        </b-row>

        <b-row class="mt-3">
          <b-col md="4">
            <label>E.Code</label>
            <b-form-input
              size="sm"
              id="eCode"
              name="eCode"
              v-model="driverModal.eCode"
              placeholder="Enter E.Code"
            ></b-form-input>
          </b-col>
          <b-col md="4">
            <label>Name of Driver <span class="error">*</span></label>
            <b-form-input
              size="sm"
              id="driverName"
              name="driverName"
              v-model="driverModal.driverName"
              placeholder="Enter Driver Name"
              :state="!errorList.driverName"
            ></b-form-input>
            <span class="error" v-if="errorList.driverName">{{ errorList.driverName }}</span>
          </b-col>
          <b-col md="4">
            <label>Father's Name <span class="error">*</span></label>
            <b-form-input
              size="sm"
              id="fathersName"
              name="fathersName"
              v-model="driverModal.fathersName"
              placeholder="Enter Father's Name"
              :state="!errorList.fathersName"
            ></b-form-input>
            <span class="error" v-if="errorList.fathersName">{{ errorList.fathersName }}</span>
          </b-col>
        </b-row>

        <h6 class="text-primary mb-3 mt-4">Contact Information</h6>
        <b-row>
          <b-col md="4">
            <label>Mobile Number <span class="error">*</span></label>
            <b-form-input
              size="sm"
              id="mobileNumber"
              name="mobileNumber"
              v-model="driverModal.mobileNumber"
              placeholder="Enter Mobile Number"
              :state="!errorList.mobileNumber"
              @blur="validateMobile(driverModal.mobileNumber)"
            ></b-form-input>
            <span class="error" v-if="errorList.mobileNumber">{{ errorList.mobileNumber }}</span>
          </b-col>
          <b-col md="4">
            <label>Date of Joining</label>
            <b-form-input
              size="sm"
              type="date"
              id="dateOfJoining"
              name="dateOfJoining"
              v-model="driverModal.dateOfJoining"
            ></b-form-input>
          </b-col>
          <b-col md="4">
            <label>Date of Leaving</label>
            <b-form-input
              size="sm"
              type="date"
              id="dateOfLeaving"
              name="dateOfLeaving"
              v-model="driverModal.dateOfLeaving"
            ></b-form-input>
          </b-col>
        </b-row>

        <b-row class="mt-3">
          <b-col md="4">
            <label>Date of Birth</label>
            <b-form-input
              size="sm"
              type="date"
              id="dateOfBirth"
              name="dateOfBirth"
              v-model="driverModal.dateOfBirth"
            ></b-form-input>
          </b-col>
          <b-col md="4">
            <label>Aadhar Number</label>
            <b-form-input
              size="sm"
              id="aadharNo"
              name="aadharNo"
              v-model="driverModal.aadharNo"
              placeholder="XXXX-XXXX-XXXX"
              @blur="validateAadhar(driverModal.aadharNo)"
            ></b-form-input>
            <span class="error" v-if="errorList.aadharNo">{{ errorList.aadharNo }}</span>
          </b-col>
          <b-col md="4">
            <label>UAN Number</label>
            <b-form-input
              size="sm"
              id="uanNumber"
              name="uanNumber"
              v-model="driverModal.uanNumber"
              placeholder="Enter UAN Number"
            ></b-form-input>
          </b-col>
        </b-row>

        <b-row class="mt-3">
          <b-col md="4">
            <label>E.S.I. Number</label>
            <b-form-input
              size="sm"
              id="esiNo"
              name="esiNo"
              v-model="driverModal.esiNo"
              placeholder="Enter ESI Number"
            ></b-form-input>
          </b-col>
          <b-col md="4">
            <label>DL Number <span class="error">*</span></label>
            <b-form-input
              size="sm"
              id="dlNumber"
              name="dlNumber"
              v-model="driverModal.dlNumber"
              placeholder="Enter DL Number"
              :state="!errorList.dlNumber"
              @blur="validateDL(driverModal.dlNumber)"
            ></b-form-input>
            <span class="error" v-if="errorList.dlNumber">{{ errorList.dlNumber }}</span>
          </b-col>
        </b-row>

        <b-row class="mt-4">
          <b-col class="text-center">
            <b-button
              type="submit"
              variant="primary"
              :disabled="isSubmitting"
              size="sm"
              class="mr-2"
            >
              <b-spinner small v-if="isSubmitting"></b-spinner>
              {{ isSubmitting ? 'Saving...' : (isEditMode ? 'Update Driver' : 'Save Driver') }}
            </b-button>
            <b-button variant="outline-secondary" @click="hideDriverModal" size="sm">
              Cancel
            </b-button>
          </b-col>
        </b-row>
      </b-form>
    </b-modal>


    <md-dialog-confirm
      :md-content-html="alert.content"
      :md-ok-text="alert.ok"
      @close="onClose3"
      ref="addPop"
    ></md-dialog-confirm>

    <md-dialog-confirm
      :md-content-html="alert.content"
      :md-ok-text="alert.ok"
      @close="onClose1"
      ref="addPop1"
    ></md-dialog-confirm>

    <md-dialog-confirm
      :md-content-html="alert.content"
      :md-ok-text="alert.ok"
      ref="addPop2"
    ></md-dialog-confirm>
  </div>
</template>

<script>
import Vue from "vue";
import DatePicker from "vue2-datepicker";
import axios from "axios";
import moment from "moment";
import CustomLoader from "../../common/customLoader.vue";
import "vue-loading-overlay/dist/vue-loading.css";
import BannerComponent from "../../allModuleForm/bannerComponent.vue";
import { ModelListSelect } from "vue-search-select";
import { URL_BASE, URL_BASE_DOC } from "../../../helper/constant.js";
import { DateFormat, selectDateFormat } from "../../../helper/filters";
import { globalPermissionStatus, GlobalContainerValid } from "../../../helper/collection";
import TrasportService from "../../../services/TrasportService.js";
import CommonService from "../../../services/CommonService.js";
import DriverService from "../../../services/DriverService.js";
export default {
  beforeMount() {
    if (
      globalPermissionStatus("Transportation") &&
      this.$sessionsStorage.get("storeQuotationId") != undefined &&
      this.$sessionsStorage.get("storeQuotationId") != "" &&
      this.$sessionsStorage.get("storeAssignId") != undefined &&
      this.$sessionsStorage.get("storeAssignId") != ""
    ) {
      this.$store.dispatch("setCurrentRoute", "/vehicle/vehicleBooking");
      this.getData1();
    } else {
      this.$router.push({
        path: "/dashboard",
      });
    }
  },
  data() {
    return {
      driverModal: {
        driverId: "",
        location: "",
        vehicleNumber: "",
        driverType: "",
        eCode: "",
        driverName: "",
        fathersName: "",
        mobileNumber: "",
        dateOfJoining: "",
        dateOfLeaving: "",
        dateOfBirth: "",
        aadharNo: "",
        uanNumber: "",
        esiNo: "",
        dlNumber: "",
      },
      driverTypeOptions: [
        { value: "Permanent", text: "Permanent" },
        { value: "Temporary", text: "Temporary" },
      ],
      errorList: {
        location: "",
        driverType: "",
        driverName: "",
        fathersName: "",
        mobileNumber: "",
        aadharNo: "",
        dlNumber: "",
      },
      isSubmitting: false,
      isEditMode: false,
      contTypeList:[
        {
          Val: "Container",
          Text: "Container",
          notEnabled: false,
        },
        {
          Val: "Loose Cargo",
          Text: "Loose Cargo",
          notEnabled: false,
        },
        {
          Val: "Empty Container",
          Text: "Empty Container",
          notEnabled: false,
        },
      ],
      UpdateGRNDetails: {
        goodReceivedID: "",
        grnIdNew: "",
        GRNSeries: "",
        grn_reset_status: 2,
        previousGRNNo: "",
      },
      vehicleTypeList: [],
      syncFlag: false,
      ContainernoErrFlag: false,
      selectDateFormat,
      docURL: URL_BASE_DOC,
      permissionStatus:
        this.$sessionsStorage.get("PermissionStatus") !== undefined &&
        this.$sessionsStorage.get("PermissionStatus") == "Read"
          ? true
          : false,
      emptyArray: [],
      newArray: {
        ids: [],
      },
      vehicleArray: "",
      getLocationData: [{ pickupLocation: "Agra" }],
      error: { vehicleSelectError: "", vehicleSelectError1: "" },
      vehicleDetails: {
        vehicleArray: [],
        addedVehicle: [],
      },
      AutoContainerType: {},
      statusList: [
        {
          statusV: "1",
          statusT: "In Transit",
        },
        {
          statusV: "2",
          statusT: "Closed",
        },
      ],
      totalCon: "",
      isLoading: false,
      alert: {
        content: "a",
        ok: "ok",
      },
      refuelData: {},
      slineNameData: {},
      vehicleBooking: {
        newContainerFlow: "",
        status: "",
        icdName: "",
        icdAddress: "",
        vehicleBookingId: "",
        jobType: [],
        showJobType: [],
        vehicleDetails: [],
        shipperCustomerName: "",
        billingPartyName: "",
        pickupLocation: "",
        destination: "",
        doValidity: "",
        icdInDate: "",
        uploadDocument: "",
        vehicleBookingDate: "",
        factoryStuffingDate: "",

        quotationId: "",
        assignId: "",
        assignSeries: "",
        clientId: "",
        salesBookingId: "",
        noOfTrucks: "",
        hubId: "",
        email: "",
      },
      checkCargo: false,
      goodReceived: {
        cont_input_type:"Container",
        NewContainerType: "",
        containerInfo: "",
        shipmentType: "",
        NewContainerTypeId: "",
        jobType: "",
        coLoaderId: "",
        transportType: "",
        commodityType: "",
        vehicleType: "",
        Description: "",
        consignee: "",
        consignor: "",
        weight: "",
        weight_remark: "",
        PODLocation: "",

        salesSeries: "",
        movementType: "",
        allModuleId: "",
        outSourceVehicleNo: "",
        outSourceGRNDate: "",
        transporterName: "",
        outSourceGRNo: "",
        tptType: "1",
        factoryOutDate: "",
        factoryInDate: "",
        customSealNo: "",
        containerQuantity: "",
        advanceCash: "",
        loginBy: this.$sessionsStorage.get("nameUser"),
        goodReceivedID: "",
        vehicleTruckId: "",
        renewVehicleTruckId: "",
        regdNo: "",
        Date: "",
        status: "1",
        containerNo: "",
        driverName: "",
        driverName1: "",
        FuelSlipNo: "",
        vehicleNo: "",
        size: "",
        reFuelstation: "",
        refuelAddress: "",
        tollCard: "",
        tollInCash: "",
        otherCashExpenses: "",
        diesel: "",
        dieselPrice: "",
        cashDeiselPaid: "",
        remarks: "",
        totalCost: "",
        clientId: this.$sessionsStorage.get("clientId"),
        quotationId: this.$sessionsStorage.get("storeQuotationId"),

        salesBookingId: this.$sessionsStorage.get("salesBookingId"),
        assignId: this.$sessionsStorage.get("storeAssignId"),
        multipleContainerType: [],
        multipleContainerTypeId: [],
        uniqueContainerArry: [],
        containerCount: [],
        assignmentContainersList: [],
        pdfGRN: "",
        GRNSeries: "",
        vendorName: "",
        slineSealNo: "",
        slineName: "",
        assignDriverId: "",
        driverId: "",
        skipGRN: "0",
        refuelContact: "",
      },
      movementTypeList: [
        {
          text: "EXPORT",
          val: "EXPORT",
        },
        {
          text: "IMPORT",
          val: "IMPORT",
        },
        {
          text: "EMPTY REPO",
          val: "EMPTY_REPO",
        },
      ],
      skipGRNList: [
        {
          text: "Yes",
          val: "1",
        },
        {
          text: "No",
          val: "0",
        },
      ],
      dieselInLiters: "",
      distance: "",
      truckAverage: "",
      alert: {
        content: "a",
        ok: "ok",
      },
      driverNameArr: [],
      type: "",
      driverNameLength: "",
      showGRNList: [],

      statusError: "",
      containerNoError: "",
      containerNoRegexError: "",
      vehicleTruckIdError: "",
      vehicleTypeError: "",
      outGrNoError: "",
      tptTypeError: "",
      slineNameError: "",
      DescriptionError: "",
      FuelSlipNoError: "",
      factoryInDateError: "",
      outSourceGRNDateError: "",
      factoryOutDateError: "",
      vehicleNoError: "",
      movementTypeError: "",
      transporterNameError: "",
      outSourceVehicleNoError: "",
      slineSealNoError: "",

      reFuelstationError: "",
      refuelStationArr: [],
      BOEDetails: [],
      DieselInLtrDetails: [],
      assignedDriverList: [],
      assignedDriverAll: [],
      grnVehicleList: [],
      refuelAddressError: "",
      dummyFuelSlip: "",

      tollCardError: "",
      tollInCashError: "",
      assignDriverIdError: "",
      otherCashExpensesError: "",
      dieselError: "",
      dieselPriceError: "",
      cashDeiselPaidError: "",
      remarksError: "",
      totalCostError: "",
      addedConarray: [],
      getContainertype: [
        {
          containerType: "Aj",
        },
      ],
      TPTtypeList: [
        {
          ccTypeVal: "1",
          ccTypeTxt: "Pridel",
        },
        {
          ccTypeVal: "2",
          ccTypeTxt: "Outsourced",
        },
        {
           ccTypeVal: "3",
           ccTypeTxt: "PRIDEL HIRING"
         }
      ],
      showAlgo: false,
      algoConNo: "",
      getShipping: [],
      ContainerSizeError: "",
      validateGoodReceived: true,
      showMoreNew: false,
      stepperWidget: {},
      vehicleBookingDateError: "",
      factoryStuffingDateError: "",
      statusError: "",
      icdNameError: "",
      icdAddressError: "",

      icdInDateError1: "",
      uploadDocumentError: "",
      value1: "",
      validateBookingForm: "",
      isActiveFollowActivities: false,
      isActiveVehicleBooking: true,

      followActivityList: {
        followActivityId: "",
        contractDisplacmentDate: "",
        stuffingDate: "",
        factoryStuffingDate: "",
        factoryDate: "",
        factoryOutDate: "",
        handoverIcd: "",
        vehicleDetinationDays: "",
        grNo: "",
        grnSeries: "",
        containerNo: "",
        size: "",
        jobNo: "",
        boeNo: "",
        customClearenceNo: "",
      },
      alert2: {
        title: "Post created!",
        contentHtml:
          "Your post <strong>Material Design is awesome</strong> has been created.",
      },
      dummyData: [],
      uploadCheck: "",
      uploadCheck1: "",

      followActivityIdError: "",

      stuffingDateError: "",
      factoryStuffingDateError: "",
      factoryDateError: "",
      factoryOutDateError: "",

      grNoError: "",
      containerNoError: "",
      sizeError: "",

      validateFollow: true,
      hubName: "",
      timmerMsg: "",
      checkContNoButton: 1,
    };
  },

  mounted() {},
  filters: {
    moment(date) {
      return moment(date).format("MMMM Do YYYY, h:mm:ss a");
    },
  },
  beforeDestroy() {
    this.$store.dispatch("setSelectedArray", { selected: [] });
    this.$store.dispatch("setUnselectedArray", []);
    this.$store.dispatch("setFixArray", []);
  },
  destroyed() {},
  components: {
    DatePicker,
    ModelListSelect,
    CustomLoader,
    BannerComponent,
  },
  computed: {
    refuelStationArrList() {
      return this.refuelStationArr;
    },
    pendingGrn() {
      return this.vehicleBooking.noOfTrucks - this.showGRNList.length;
    },
    grnListError() {
      return this.showGRNList.length != this.$store.getters.getSelectedArray.length ||
        this.goodReceived.goodReceivedID != ""
        ? true
        : false;
    },
    containerList() {
      return this.getContainertype;
    },

    ShippingList() {
      return this.getShipping;
    },
    viewVBUpload() {
      return this.vehicleBooking.uploadDocument.split(",");
    },
    DisabledGRN() {
      return this.showGRNList.length > 1 ? true : false;
    },
    checkIsDisabled() {
      return false;
    },
    unCheckItems() {
      this.JqueryFun();

      return this.$store.getters.getUnselectedArray;
    },
    checkItems() {
      this.JqueryFun();

      return this.$store.getters.getSelectedArray;
    },
    licenseState() {
      if (!this.driverModal.license_no) return null;
      return this.errorList.license_no ? false : true;
    },
  },
  watch: {
    refuelData: {
      handler: function (newVal, oldVal) {
        this.refuelAddress1(newVal);
      },
      deep: true,
    },
    goodReceived: {
      handler(newVal, oldVal) {
        if (newVal.hasOwnProperty("containerNo")) {
          this.goodReceived.containerNo = newVal.containerNo.toUpperCase();
        }
      },
      deep: true,
    },
  },
  methods: {
    validateLicense(license_no) {
      const pattern = /^[A-Z]{2}[0-9]{2}[0-9]{4}[0-9]{7}$/;
      if (!license_no) {
        this.errorList.license_no = "Please Enter Driver License No.";
        return false;
      }
      if (!pattern.test(license_no)) {
        this.errorList.license_no = "Invalid license number format!";
        return false;
      }
      this.errorList.license_no = "";
      return true;
    },
    openDriverModal() {
      this.resetDriverModal();
      this.$refs["Driver-modal"].show();
    },
    hideDriverModal() {
      this.$refs["Driver-modal"].hide();
      this.resetDriverModal();
    },
    resetDriverModal() {
      this.driverModal = {
        driverId: "",
        driver_fname: "",
        driver_lname: "",
        driver_mname: "",
        license_no: "",
      };
      this.errorList = {
        driver_fname: "",
        driver_lname: "",
        driver_mname: "",
        license_no: "",
      };
    },
    validateDriver() {
      let validate_new = true;
      Object.keys(this.errorList).map((x, index) => {
        if (this.driverModal[x] == "") {
          this.errorList[x] = this.driverError[index];
          validate_new = false;
        }
      });
      if (validate_new != true) {
        this.validate = false;
      } else {
        this.validate = true;
      }
    },
    validateMobile(mobileNumber) {
      if (!mobileNumber) {
        this.errorList.mobileNumber = "Please enter mobile number";
        return false;
      }
      const pattern = /^[6-9]\d{9}$/;
      if (!pattern.test(mobileNumber)) {
        this.errorList.mobileNumber = "Please enter valid 10-digit mobile number";
        return false;
      }
      this.errorList.mobileNumber = "";
      return true;
    },

    validateAadhar(aadharNo) {
      if (!aadharNo) {
        this.errorList.aadharNo = "";
        return true; // Optional field
      }
      const pattern = /^\d{4}-\d{4}-\d{4}$/;
      if (!pattern.test(aadharNo)) {
        this.errorList.aadharNo = "Please enter valid Aadhar number (XXXX-XXXX-XXXX)";
        return false;
      }
      this.errorList.aadharNo = "";
      return true;
    },

    validateDL(dlNumber) {
      if (!dlNumber) {
        this.errorList.dlNumber = "Please enter DL number";
        return false;
      }
      const pattern = /^[A-Z]{2}[0-9]{2}[0-9]{4}[0-9]{7}$/;
      if (!pattern.test(dlNumber)) {
        this.errorList.dlNumber = "Please enter valid DL number format";
        return false;
      }
      this.errorList.dlNumber = "";
      return true;
    },

    validateDriverForm() {
      let isValid = true;
      if (!this.driverModal.location) {
        this.errorList.location = "Please enter location";
        isValid = false;
      } else {
        this.errorList.location = "";
      }

      if (!this.driverModal.driverType) {
        this.errorList.driverType = "Please select driver type";
        isValid = false;
      } else {
        this.errorList.driverType = "";
      }

      if (!this.driverModal.driverName) {
        this.errorList.driverName = "Please enter driver name";
        isValid = false;
      } else {
        this.errorList.driverName = "";
      }

      if (!this.driverModal.fathersName) {
        this.errorList.fathersName = "Please enter father's name";
        isValid = false;
      } else {
        this.errorList.fathersName = "";
      }

      if (!this.driverModal.mobileNumber) {
        this.errorList.mobileNumber = "Please enter mobile number";
        isValid = false;
      } else if (!this.validateMobile(this.driverModal.mobileNumber)) {
        isValid = false;
      }

      if (!this.driverModal.dlNumber) {
        this.errorList.dlNumber = "Please enter DL number";
        isValid = false;
      } else if (!this.validateDL(this.driverModal.dlNumber)) {
        isValid = false;
      }

      if (this.driverModal.aadharNo && !this.validateAadhar(this.driverModal.aadharNo)) {
        isValid = false;
      }

      return isValid;
    },

    openDriverModal(driver = null) {
      this.resetDriverModal();
      if (driver) {
        this.isEditMode = true;
        this.populateDriverModal(driver);
      } else {
        this.isEditMode = false;
      }
      this.$refs["Driver-modal"].show();
    },

    hideDriverModal() {
      this.$refs["Driver-modal"].hide();
    },

    resetDriverModal() {
      this.driverModal = {
        driverId: "",
        location: "",
        vehicleNumber: "",
        driverType: "",
        eCode: "",
        driverName: "",
        fathersName: "",
        mobileNumber: "",
        dateOfJoining: "",
        dateOfLeaving: "",
        dateOfBirth: "",
        aadharNo: "",
        uanNumber: "",
        esiNo: "",
        dlNumber: "",
      };
      this.errorList = {
        location: "",
        driverType: "",
        driverName: "",
        fathersName: "",
        mobileNumber: "",
        aadharNo: "",
        dlNumber: "",
      };
      this.isEditMode = false;
    },

    populateDriverModal(driver) {
      const formatDateForInput = (dateString) => {
        if (!dateString || dateString === '' || dateString === 'null') {
          return '';
        }
        
        try {
          const date = new Date(dateString);
          if (isNaN(date.getTime())) {
            return '';
          }
          return date.toISOString().split('T')[0];
        } catch (error) {
          console.error('Error formatting date:', dateString, error);
          return '';
        }
      };

      this.driverModal = {
        driverId: driver.driverId || "",
        location: driver.driverLocation || "",
        vehicleNumber: driver.driverVehicleNumber || "",
        driverType: driver.driverType === "1" ? "Permanent" : "Temporary",
        eCode: driver.driverECode || "",
        driverName: driver.driverName || "",
        fathersName: driver.driver_fname || "",
        mobileNumber: driver.driverContact || "",
        dateOfJoining: formatDateForInput(driver.driverDateOfJoining),
        dateOfLeaving: formatDateForInput(driver.driverDateOfLeaving),
        dateOfBirth: formatDateForInput(driver.driverDateOfBirth),
        aadharNo: driver.driverAadharNumber || "",
        uanNumber: driver.driverUANNumber || "",
        esiNo: driver.driverEsic || "",
        dlNumber: driver.license_no || "",
      };
      
      console.log('Populated modal data:', this.driverModal);
    },

    addDriver() {
      if (!this.validateDriverForm()) {
        this.showError("Please fill all required fields correctly");
        return;
      }

      this.isSubmitting = true;

      const payload = {
        driverLocation: this.driverModal.location,
        driverVehicleNumber: this.driverModal.vehicleNumber,
        driverType: this.driverModal.driverType === "Permanent" ? "1" : "2",
        driverECode: this.driverModal.eCode,
        driverName: this.driverModal.driverName,
        driver_fname: this.driverModal.fathersName,
        driverContact: this.driverModal.mobileNumber,
        driverDateOfJoining: this.driverModal.dateOfJoining,
        driverDateOfLeaving: this.driverModal.dateOfLeaving,
        driverDateOfBirth: this.driverModal.dateOfBirth,
        driverAadharNumber: this.driverModal.aadharNo,
        driverUANNumber: this.driverModal.uanNumber,
        driverEsic: this.driverModal.esiNo,
        license_no: this.driverModal.dlNumber,
      };

      // Use DriverService for API calls
      const serviceCall = this.isEditMode
        ? DriverService.updateDriver(this.driverModal.driverId, payload)
        : DriverService.createDriver(payload);

      serviceCall
        .then((response) => {
          if (response.status === 200 && response.data) {
            this.showSuccess(this.isEditMode ? "Driver updated successfully" : "Driver added successfully");
            this.hideDriverModal();
            this.fetchDriverData();
          } else {
            throw new Error(this.isEditMode ? "Failed to update driver" : "Failed to add driver");
          }
        })
        .catch((error) => {
          const message = this.isEditMode ? "Failed to update driver" : "Failed to add driver";
          this.showError(message);
          console.error("Error saving driver:", error);
        })
        .finally(() => {
          this.isSubmitting = false;
        });
    },

    fetchDriverData() {
      console.log("Refreshing driver data...");
      this.getData1();
    },

    showSuccess(message) {
      this.alert.content = message;
      this.alert.ok = "OK";
      this.$refs["addPop"].open();
    },

    showError(message) {
      this.alert.content = message;
      this.alert.ok = "OK";
      this.$refs["addPop"].open();
    },
    openModalGRNNO(item) {
      this.UpdateGRNDetails = {
        goodReceivedID: "",
        grnIdNew: "",
        GRNSeries: "",
        grn_reset_status: 2,
        previousGRNNo: "",
      };
      this.UpdateGRNDetails.previousGRNNo = item.GRNSeries;
      this.UpdateGRNDetails.goodReceivedID = item.goodReceivedID;
      this.$refs["Reset-GRNNO-modal"].show();
    },
    hideModalGRNNO() {
      this.UpdateGRNDetails = {
        goodReceivedID: "",
        grnIdNew: "",
        GRNSeries: "",
        grn_reset_status: 2,
        previousGRNNo: "",
      };
      this.$refs["Reset-GRNNO-modal"].hide();
    },

    ResetGRNNO() {
      this.UpdateGRNDetails.GRNSeries = "GRN/" + this.UpdateGRNDetails.grnIdNew;
      if (this.UpdateGRNDetails.grnIdNew != "" && this.UpdateGRNDetails.grnIdNew > 0) {
        let paylod = {
          UpdateGRNDetails: this.UpdateGRNDetails,
          itemCode: "RESETGRNNO",
        };
        TrasportService.getAllTrasportList(JSON.stringify(paylod))
          .then((response) => {
            const { data, status, statusText } = response;
            if (status == 200 && data) {
              this.getData1();
            }
          })
          .catch((error) => {
            console.log("Catch on getAllTrasportList Error: ", error);
          });
      }
    },

    clearFuelSlip() {
      if (this.goodReceived.skipGRN == "0") {
        this.goodReceived.FuelSlipNo = this.dummyFuelSlip;
      } else {
        this.goodReceived.FuelSlipNo = "";
      }
    },
    clear2Con() {
      this.totalCon = "";
    },
    shiftContainer() {
      this.totalCon = this.goodReceived.containerNo;
      this.goodReceived.containerNo = "";
    },
    getConAlgoList() {
      //let self = this;

      if (this.goodReceived.containerNo != "") {
        this.validContainerNo = GlobalContainerValid(this.goodReceived.containerNo);
      }
    },
    changeDataOnTPTType() {
      this.getData1();
    },
    showMoreContainer() {
      if (this.showMoreNew == false) {
        this.showMoreNew = true;
      } else {
        this.showMoreNew = false;
      }
    },
    fetchDriverFromVehicle() {
      let arrayD = this.grnVehicleList.filter((x) => {
        return x.vehicleTruckId == this.goodReceived.vehicleTruckId;
      });
      this.goodReceived.vehicleType = arrayD[0].vehicleType;
    },
    goToMailPage(ID) {
      this.$sessionsStorage.set("consomailORtrack", ID);

      this.$router.push({
        path: "/vehicleQuotation/tranportMailDetails",
      });
    },
    goToVehcileDetail() {
      this.$sessionsStorage.set("VehicleCount", this.vehicleBooking.noOfTrucks);
      this.$router.push({
        path: "/vehicleQuotation/vehicleDetailLocation",
      });
    },
    showMultipleCargo() {
      if (this.checkCargo == false) {
        this.checkCargo = true;
      } else {
        this.checkCargo = false;
      }
    },
    doLoading() {
      this.isLoading = true;
    },
    doLoadingClose() {
      this.isLoading = true;

      setTimeout(() => {
        this.isLoading = false;
      }, 500);
    },

    onClose1(type) {
      if (type != "cancel") {
        let array1 = this.showGRNList.filter((x) => {
          return x.status == "1";
        });
        let transportType = this.vehicleBooking.bookingNo.split('/')[1];
        if(transportType=='Imp'){
          transportType='Import';
        }else if(transportType=='Exp'){
          transportType='Export';
        }else{
          transportType='Export';
        }

        if (array1.length == 0) {
          this.$router.push({
            path: "/vehicle/invoice?JobType=TPT&ShipmentType=Sea&ModuleType="+transportType,
          });
        } else {
          this.alert.content = "Your " + array1.length + " vehicle is still in transit";
          this.$refs["addPop2"].open();
        }
      }
    },

    onClose3(type) {
    },
    onSubmitTable() {
      this.$store.dispatch("setSelectedArray", { selected: this.newArray.ids });
      this.emptyArray = Array(this.emptyArray.length).fill(false);
      this.JqueryFun();
      this.$refs["dialog1"].close();
    },

   
    Print(item) {
      if (!item) return;
      this.openSignedDocument(item);
    },
   

    validateFollowActivities() {
      let validate_new = true;

      if (this.followActivityList.factoryDate == "") {
        $("#factoryDate").focus();
        this.factoryDateError = "Select Date";
        validate_new = false;
      }

      if (this.followActivityList.factoryOutDate == "") {
        $("#factoryOutDate").focus();
        this.factoryOutDateError = "Select Date";
        validate_new = false;
      }

      if (validate_new != true) {
        this.validateFollow = false;
      } else {
        this.validateFollow = true;
      }
    },

    expandEvent() {},
    deleteContainer(item, index) {
      console.log(item);
      let i = this.goodReceived.multipleContainerType.indexOf(item);

      this.goodReceived.multipleContainerType.splice(i, 1);
      this.goodReceived.multipleContainerTypeId.splice(i, 1);

      if (this.vehicleBooking.newContainerFlow == "1") {
        this.getContainertype.push(this.addedConarray[i]);

        this.goodReceived.uniqueContainerArry.splice(i, 1);
        this.addedConarray.splice(i, 1);
        if (index == "1") {
          this.totalCon = "";
        } else {
          if (this.totalCon) {
            this.goodReceived.containerNo = this.totalCon;
            this.totalCon = "";
          } else {
            this.goodReceived.containerNo = "";
          }
        }
      }
    },
    previousQuotation() {
      window.history.go(-1);
     
    },

    goodsReceived() {
     
      let payload = {
        followList: this.followActivityList,
      };
      console.log(payload);
      //   return false;
      if (this.validateFollow != false) {
        $("#addButtonLoader").css("display", "none");
        $("#loader").css("display", "block");
        let options = {
          method: "POST",
          url: `${URL_BASE}/Api_Transport/addFollowActivity.php`,
          data: JSON.stringify(payload),

          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: this.$sessionsStorage.get("loginId"),
          },
        };
        axios(options)
          .then((result) => {
            const { statusText, status, data } = result;
            if (status == 200 && data) {
              if (data.msg == "Inserted Successfully") {
                this.alert.content = "Added Successfully";
              } else {
                this.alert.content = "Data Updated Successfully";
              }

              $("#addButtonLoader").css("display", "block");
              $("#loader").css("display", "none");
              this.$sessionsStorage.set("storeGenerateGrn", data.grnId);
              this.$sessionsStorage.set("storefollowActivityId", data.followActivityId);

              this.$refs["addPop1"].open();
            }
          })
          .catch((err) => {
            throw err;
          });
      }
    },
    
    assignmentOrder() {
      this.$router.push({
        name: "Assignment Order",
        path: "/vehicle/assignmentOrder",
        name: "Assignment Order",
      });
    },

    
    masterCallbackContainer(item) {
      console.log("Mydata=>", item);
      
      let b = this.containerCount.filter((x) => {
        return x.containerTypeID == item.containerTypeId;
      })[0];

      let count = 0;

      this.goodReceived.multipleContainerTypeId.map((x) => {
        if (x == item.containerTypeId) {
          count++;
        }
      });

      if (count < b.noOfContainer && this.goodReceived.multipleContainerType.length < 2) {
        this.goodReceived.multipleContainerType.push(item.containerType);
        this.goodReceived.multipleContainerTypeId.push(item.containerTypeId);
        if (item.uniqueContainerId) {
          console.log(this.getContainertype, item);
          this.goodReceived.uniqueContainerArry.push(item.uniqueContainerId);
          this.addedConarray.push(item);
          let index = this.getContainertype.findIndex(
            (x) => x.uniqueContainerId === item.uniqueContainerId
          );
          console.log(index);
          this.getContainertype.splice(index, 1);
          if (this.BOEDetails[0].type == "Import") {
            if (
              this.goodReceived.multipleContainerTypeId.length > 1 &&
              item.containerNo
            ) {
              this.totalCon = item.containerNo;
            } else {
              this.goodReceived.containerNo = item.containerNo;
            }
          }
        }
      } else {
        this.alert.content =
          "You can Select only " + b.noOfContainer + " Container of this type ..!";
        this.$refs["addPop"].open();
      }

    },

    formatDate(date) {
      var d = new Date(date),
        month = "" + (d.getMonth() + 1),
        day = "" + d.getDate(),
        year = d.getFullYear(),
        minute = d.getMinutes(),
        Hour = d.getHours(),
        second = d.getSeconds();

      if (month.length < 2) month = "0" + month;
      if (day.length < 2) day = "0" + day;

      let dateNew = [year, month, day].join("-");
      let minuteNew = [Hour, minute].join(":");

      return dateNew + " " + minuteNew;
    },
    JqueryFun() {
      return $(function () {
        $("#truckDetail").DataTable();
        $("#truckDetail2").DataTable();
        $("#truckDetail5").DataTable();
      });
    },

    onClose(type) {
      if (type != "cancel") {
        this.$router.push({
          path: "/vehicle/vehicleBooking",
        });
      }
    },

    showGRN(item) {
      let id = item.goodReceivedID;
      let MyContainerNo = item.containerNo;

      console.log(item);
      console.log(this.assignmentContainersList);
      this.assignmentContainersList.forEach((element) => {
        if (MyContainerNo == element.containerNo) {
          this.goodReceived.newuniqueContainerId = element.uniqueContainerId;
        }
      });

      console.log(item);
      console.log("this.goodReceived=>", this.goodReceived);
      window.scrollTo(0, 400);
      if (item.tptType == "2" || item.tptType == "3") {
        this.grnVehicleList = [];
        this.grnVehicleList = this.vehicleTypeList;
      }
      console.log("this.vehicleTypeList=>", this.vehicleTypeList);

      let array = this.showGRNList.filter((x) => {
        return x.goodReceivedID == id;
      });

      if (array[0].assignDriverId != 0) {
        this.goodReceived.assignDriverId = array[0].assignDriverId;
        this.checkCargo = true;
      }
      Object.keys(array[0]).map((x) => {
        this.goodReceived[x] = array[0][x] || "";
        if (x == "refuelStation") {
          this.goodReceived["reFuelstation"] = array[0][x] || "";
        }
        if (x == "masterdriverName") {
          this.goodReceived.driverName1 = array[0][x];
        }
        if (x == "size") {
          this.goodReceived.size = array[0][x];
        }
        if (x == "vehicleNo") {
          this.goodReceived.outSourceVehicleNo = array[0][x];
        }

        if (x == "multipleContainerType" || x == "multipleContainerTypeId") {
          this.goodReceived[x] = array[0][x].split(",") || [];
        }
      });
    },

    validateGoodReceivedForm() {
      let validate_new = true;

      var containerformat = new RegExp("^[a-zA-Z]{4}[0-9]{7}$");
      if (this.goodReceived.tptType == "") {
        $("#tptType").focus();
        this.tptTypeError = "Select Transportation By";
        validate_new = false;
      }

      if (
        this.goodReceived.outSourceGRNo == "" &&
        (this.goodReceived.tptType == "2" || this.goodReceived.tptType == "3") &&
        this.goodReceived.skipGRN == "1"
      ) {
        $("#outSourceGRNo").focus();
        this.outGrNoError = "Enter OutSource GR";
        validate_new = false;
      }

      if (this.goodReceived.vehicleTruckId == "" && this.goodReceived.tptType == "1") {
        $("#driverName").focus();
        this.vehicleTruckIdError = "Select Vehicle";
        validate_new = false;
      }
      if (this.goodReceived.vehicleType == "") {
        $("#driverName").focus();
        this.vehicleTypeError = "Select Vehicle Type";
        validate_new = false;
      }

      if (
        this.goodReceived.containerInfo == "fcl" &&
        this.goodReceived.NewContainerTypeId.indexOf("15") < 0
      ) {
        if (
          this.goodReceived.slineName == "" ||
          this.goodReceived.slineName == undefined ||
          this.goodReceived.slineName == "undefined" ||
          this.goodReceived.slineName == null ||
          this.goodReceived.slineName == "null"
        ) {
          $("#slineName").focus();
          this.slineNameError = "Select Shipping-Line";
          validate_new = false;
        }
        if (!this.goodReceived.slineSealNo) {
          $("#movementType").focus();
          this.slineSealNoError = "Enter Sline Seal No ";
          validate_new = false;
        }
      }

      if (this.goodReceived.containerNo == "") {
        $("#containerNo").focus();
        this.containerNoError = "Enter your container no";
        validate_new = false;
      }

      if (!this.goodReceived.factoryOutDate && this.goodReceived.status == "2") {
        $("#factoryOutDate").focus();
        this.factoryOutDateError = "Enter Factory Out Date";
        validate_new = false;
      }
      if (!this.goodReceived.factoryInDate && this.goodReceived.status == "2") {
        $("#factoryInDate").focus();
        this.factoryInDateError = "Enter Factory In Date";
        validate_new = false;
      }
      if (this.goodReceived.FuelSlipNo == "" && this.goodReceived.skipGRN == "0") {
        $("#FuelSlipNo").focus();
        this.FuelSlipNoError = "Enter your fuel slip no";
        validate_new = false;
      }

      if (this.goodReceived.reFuelstation == "" && this.goodReceived.tptType == "1") {
        $("#reFuelstation").focus();
        this.reFuelstationError = "Enter your refuel station";
        validate_new = false;
      }

      if (this.goodReceived.multipleContainerType.length > 0) {
        this.ContainerSizeError = "";
      } else {
        this.ContainerSizeError = "Select atleast 1 container";
        validate_new = false;
      }

      if (this.goodReceived.tollInCash == "" && this.goodReceived.tptType == "1") {
        $("#tollInCash").focus();
        this.tollInCashError = "Enter toll cash";
        validate_new = false;
      }

      if (this.goodReceived.otherCashExpenses == "" && this.goodReceived.tptType == "1") {
        $("#otherCashExpenses").focus();
        this.otherCashExpensesError = "Enter other cash expense";
        validate_new = false;
      }

      if (!this.goodReceived.movementType) {
        $("#movementType").focus();
        this.movementTypeError = "Enter movement type";
        validate_new = false;
      }

      if (this.goodReceived.dieselPrice == "" && this.goodReceived.tptType == "1") {
        $("#dieselPrice").focus();
        this.dieselPriceError = "Enter diesel Rate";
        validate_new = false;
      }
      if (this.goodReceived.cashDeiselPaid == "" && this.goodReceived.tptType == "1") {
        $("#cashDeiselPaid").focus();
        this.cashDeiselPaidError = "Enter cash paid";
        validate_new = false;
      }

      if (validate_new != true) {
        this.validateGoodReceived = false;
      } else {
        this.validateGoodReceived = true;
        this.vehicleTruckIdError = "";
        this.containerNoError = "";
        this.vehicleNoError = "";
      }
    },
    containerFilter(list, query) {
      return this.getContainertype.filter((x) => {
        return x.containerType.toLowerCase().includes(query.toLowerCase());
      });
    },
    ShippingFilter(list, query) {
      return this.getShipping.filter((x) => {
        return x.shippingLine.toLowerCase().includes(query.toLowerCase());
      });
    },

    openGenerateGRNDialog() {
      this.$refs["dialog1"].open();
      this.JqueryFun();
    },

    previousBooking() {
      this.$router.push({
        path: "/vehicle/vehicleBooking",
      });
    },

    addClient() {
      this.$router.push({
        path: "/client/addClient",
        name: "Add Clients",
      });
    },
    showQuotation() {
      this.$router.push({
        name: "Vehicle Quotation",
        path: "/vehicle/quotation",
      });
    },

    finalActivityCost() {
    },

    generateGrnForm() {
      this.validateGoodReceivedForm();
      
      if (
        this.goodReceived.shipmentType != "1" &&
        this.goodReceived.NewContainerTypeId.indexOf("15") < 0 &&
        this.goodReceived.transportType != "Export" &&
        this.goodReceived.containerInfo != "lcl" &&
        this.goodReceived.containerNo != ""
      ) {
        if (this.containerNoRegexError == "Enter Valid Container No. Format") {
          this.validateGoodReceived = false;
        }
      }
      if (this.totalCon != "") {
        let sCon = this.totalCon;
        let fCon = this.goodReceived.containerNo;
        this.goodReceived.containerNo = fCon + "," + sCon;
      }

      if (this.goodReceived.multipleContainerTypeId.length > 1) {
        let conNo = this.goodReceived.containerNo.split(",").length;

        if (conNo <= 1) {
          this.alert.content = "Plz Enter Container No for all seleted Container Type";
          this.$refs["addPop2"].open();
          return false;
        }
      }

      if (this.goodReceived.tptType == "1") {
        if (this.goodReceived.assignDriverId != "" && this.checkCargo == true) {
          let array = this.assignedDriverAll.filter((x) => {
            return x.driverId == this.goodReceived.assignDriverId;
          });

          if (array.length > 0) {
            this.goodReceived["assignedDriverName"] = array[0].driverName;
            this.goodReceived["assignedDriverContact"] = array[0].driverContact;
          }
        } else {
          this.goodReceived.assignDriverId = "";
          this.goodReceived["assignedDriverName"] = "";
          this.goodReceived["assignedDriverContact"] = "";
        }

        if (this.goodReceived.goodReceivedID == "") {
          let arrayTruck = this.grnVehicleList.filter((x) => {
            return x.vehicleTruckId == this.goodReceived.vehicleTruckId;
          });

          if (arrayTruck.length > 0) {
            this.goodReceived["vehicleNo"] = arrayTruck[0].regdNo;

            this.goodReceived["driverName"] = arrayTruck[0].driverName;
            this.goodReceived["driverContact"] = arrayTruck[0].driverContact;
          }
        } else if (
          this.goodReceived.vehicleTruckId != this.goodReceived.renewVehicleTruckId
        ) {
          let arrayTruck = this.grnVehicleList.filter((x) => {
            return x.vehicleTruckId == this.goodReceived.vehicleTruckId;
          });

          if (arrayTruck.length > 0) {
            this.goodReceived["vehicleNo"] = arrayTruck[0].regdNo;
            this.goodReceived["driverName"] = arrayTruck[0].driverName;
            this.goodReceived["driverContact"] = arrayTruck[0].driverContact;
          }
        } else {
          this.goodReceived["vehicleNo"] = this.goodReceived.regdNo;

          this.goodReceived["driverName"] = this.goodReceived.driverName;
        }
      } else {
        this.goodReceived.vehicleNo = this.goodReceived.outSourceVehicleNo;
      }

      let arrayShippping = this.ShippingList.filter((x) => {
        return x.shippingId == this.goodReceived.slineName;
      });

      console.log("Happy SIngh=>", arrayShippping);

      if (
        this.goodReceived.shipmentType != "1" &&
        this.goodReceived.NewContainerTypeId.indexOf("15") < 0 &&
        this.goodReceived.transportType != "Export" &&
        this.goodReceived.containerInfo != "lcl"
      ) {
        this.goodReceived["shippingLineNameNew"] = arrayShippping[0].shippingLine;
        this.goodReceived["shippingLine"] = arrayShippping[0].shippingLine;
      }
      this.goodReceived["newContainerFlow"] = this.vehicleBooking.newContainerFlow;

      let payload = {
        goodReceived: this.goodReceived,
        storeFollow: this.followActivityList,
      };

      if (
        this.goodReceived.skipGRN == undefined ||
        this.goodReceived.skipGRN == null ||
        this.goodReceived.skipGRN == "" ||
        this.goodReceived.skipGRN == "undefined" ||
        this.goodReceived.skipGRN == "null"
      ) {
        this.alert.content = "Please Refresh Page and Choose Skip GRN";
        this.$refs["addPop"].open();
        return false;
      } else if (
        this.goodReceived.movementType == undefined ||
        this.goodReceived.movementType == null ||
        this.goodReceived.movementType == "" ||
        this.goodReceived.movementType == "undefined" ||
        this.goodReceived.movementType == "null"
      ) {
        this.alert.content = "Please Choose Moment Type";
        this.$refs["addPop"].open();
        return false;
      }
      if (arrayShippping.length > 0) {
        this.goodReceived["shippingLineNameNew"] = arrayShippping[0].shippingLine;
        this.goodReceived["shippingLineNameNew"] = arrayShippping[0].shippingLine;
      }

      if (this.validateGoodReceived != false) {
        $("#addButtonLoader11").css("display", "none");
        $("#loader11").css("display", "block");
        let options = {
          method: "POST",
          url: `${URL_BASE}/addGenerateGrnVP.php`,
          data: JSON.stringify(payload),

          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: this.$sessionsStorage.get("loginId"),
          },
        };
        axios(options)
          .then((result) => {
            const { statusText, status, data } = result;
            if (result && data && status == 200) {
              if (data.GRN_FLAG) {
                this.alert.content = data.GRN_MSG;
              }
              $("#addButtonLoader11").css("display", "block");
              $("#loader11").css("display", "none");

              this.$refs["addPop"].open();

              if (data.GRN_FLAG == 1) {
                this.$sessionsStorage.set("storeGenerateGrn", data.goodReceivedID);
                this.$sessionsStorage.set("storefollowActivityId", data.followActivityId);
              }
              this.goodReceived.uniqueContainerArry = [];
              this.goodReceived.driverId = "";
              this.goodReceived.FuelSlipNo = "";
              this.goodReceived.vehicleTruckId = "";
              this.goodReceived.vehicleNo = "";
              this.goodReceived.containerNo = "";
              this.goodReceived.size = "";
              this.goodReceived.remarks = "";
              this.goodReceived.goodReceivedID = "";
              this.goodReceived.goodReceivedID = "";
              this.goodReceived.driverId = "";
              this.goodReceived.driverName = "";
              this.goodReceived.assignDriverId = "";
              this.goodReceived.slineSealNo = "";
              this.goodReceived.slineName = "";
              this.checkCargo = false;
              this.goodReceived.otherCashExpenses = "";
              this.goodReceived.dieselPrice = "";
              this.goodReceived.tollInCash = "";
              this.goodReceived.cashDeiselPaid = "";
              this.goodReceived.multipleContainerType = [];
              this.goodReceived.multipleContainerTypeId = [];
              this.goodReceived.cont_input_type = "Container";
              
              this.totalCon = "";
              this.getData1();
            }
          })
          .catch((error) => {});
      }
    },
   

    containerNoRegexfun_bak() {
      this.showAlgo = true;
      this.getConAlgoList();
      this.algoConNo = this.validContainerNo;

      let containerformat = new RegExp("^[a-zA-Z]{4}[0-9]{7}$");
      if (containerformat.test(this.goodReceived.containerNo)) {
        this.containerNoRegexError = "";
        let alraedyAdded = this.assignmentContainersList.filter((p) => {
          return (
            p.containerNo == this.goodReceived.containerNo &&
            p.tptGrnId != "0" &&
            this.BOEDetails != "Import"
          );
        });

        if (alraedyAdded.length > 0) {
          this.containerNoRegexError = "Entered Container No. Already Exists";
        } else {
          this.containerNoRegexError = "";
        }
      } else {
        this.containerNoRegexError = "Enter Valid Container No. Format";
      }
    },

    getContainerText(){
      this.checkContNoButton=1;
      this.containerNoRegexError = "";
      if(this.goodReceived.cont_input_type!=='Container'){
        this.goodReceived.containerNo=this.goodReceived.cont_input_type;
      }
    },
    checkForComma(containerNo) {
      return containerNo.includes(",");
    },
    containerNoRegexfun() {
      this.checkContNoButton=1;
      this.containerNoRegexError = "";
      this.showAlgo = true;
      this.getConAlgoList();
      this.algoConNo = this.validContainerNo;

      let containerformat = new RegExp("^[a-zA-Z]{4}[0-9]{7}$");
      console.log(
        "this.goodReceived.uniqueContainerArry=>",
        this.goodReceived.multipleContainerTypeId,
        this.goodReceived.uniqueContainerId
      );
      if (this.goodReceived.multipleContainerTypeId.length > 0) {
        let isValidContainer = this.checkForComma(this.goodReceived.containerNo);
        console.log("isValidContainer checkForComma PS=>", isValidContainer);
        if (isValidContainer) {
          console.log("isValidContainer checkForComma PS this.goodReceived=>", this.goodReceived);
          if (
            this.goodReceived.containerNo &&
            this.goodReceived.containerNo.trim() !== ""
          ) {
            let containerArray = this.goodReceived.containerNo
              .split(",")
              .map((item) => item.trim());
            if (
              this.goodReceived.multipleContainerTypeId.length !== containerArray.length && this.goodReceived.NewContainerTypeId!=='16'
            ) {
              this.containerNoRegexError = "Enter Valid Container No. With Count";
              this.checkContNoButton=3;
              return false;
            }

            let invalidContainers = containerArray.filter(
              (container) => !containerformat.test(container)
            );
            if (
              this.goodReceived.NewContainerTypeId === '16' &&
              (containerArray.length < 1 || containerArray.length > 2)
            ) {
              this.containerNoRegexError = "Container count must be either 1 or 2 for this type";
              this.checkContNoButton = 3;
              return false;
            }

            this.validationResult = {
              valid: invalidContainers.length === 0,
              invalidContainers: invalidContainers,
            };
            if (invalidContainers.length > 0) {
              this.containerNoRegexError =
                "Enter Valid Container No. Format" + invalidContainers.toString();
                this.checkContNoButton=3;
                return false;
            } else {
              this.containerNoRegexError = "";
            }
          }
        }else{
          if (containerformat.test(this.goodReceived.containerNo)) {
            return new Promise((resolve) => {
              let option_details = {
                module_type: "TPT Transportation",
                containerNo: this.goodReceived.containerNo,
                goodReceivedID: this.goodReceived.goodReceivedID,
                allModuleId: this.vehicleBooking.allModuleId,
              };
              if (option_details != "") {
                let options = {
                  method: "POST",
                  url: `${URL_BASE}/Api_SlineBillingCCExport/checkContainerNoExist.php`,
                  data: JSON.stringify(option_details),
                  crossDomain: true,

                  headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                    Authorization: this.$sessionsStorage.get("loginId"),
                  },
                };

                axios(options)
                  .then((result) => {
                    const { statusText, status, data } = result;
                    if (status == 200 && data) {
                      if (data.find == 1) {
                        this.ContainernoErrFlag = true;
                        this.containerNoRegexError = data.MSG;
                      } else if (data.find == 0) {
                        this.ContainernoErrFlag = false;
                        this.containerNoRegexError = "";
                      }

                      this.syncFlag = true;
                      return resolve(!this.ContainernoErrFlag);
                    }
                  })
                  .catch((error) => {});
              }
            });
          } else {
            this.containerNoRegexError = "Enter Valid Container No. Format";
            this.checkContNoButton=3;
            return false;
          }
        }
      } else {
        if (containerformat.test(this.goodReceived.containerNo)) {
          return new Promise((resolve) => {
            let option_details = {
              module_type: "TPT Transportation",
              containerNo: this.goodReceived.containerNo,
              goodReceivedID: this.goodReceived.goodReceivedID,
              allModuleId: this.vehicleBooking.allModuleId,
            };
            if (option_details != "") {
              let options = {
                method: "POST",
                url: `${URL_BASE}/Api_SlineBillingCCExport/checkContainerNoExist.php`,
                data: JSON.stringify(option_details),
                crossDomain: true,

                headers: {
                  Accept: "application/json",
                  "Content-Type": "application/json",
                  Authorization: this.$sessionsStorage.get("loginId"),
                },
              };

              axios(options)
                .then((result) => {
                  const { statusText, status, data } = result;
                  if (status == 200 && data) {
                    console.log(data);
                    console.log(data.find);
                    // alert(data.find);
                    if (data.find == 1) {
                      this.ContainernoErrFlag = true;
                      this.containerNoRegexError = data.MSG;
                    } else if (data.find == 0) {
                      this.ContainernoErrFlag = false;
                      this.containerNoRegexError = "";
                    }

                    this.syncFlag = true;
                    return resolve(!this.ContainernoErrFlag);
                  }
                })
                .catch((error) => {});
            }
          });
        } else {
          this.containerNoRegexError = "Enter Valid Container No. Format";
          this.checkContNoButton=3;
          return false;
        }
      }
    },
    CheckContainerNumber() {
      console.log("this.goodReceived=>", this.goodReceived);
      if (this.goodReceived.containerNo && this.goodReceived.allModuleId) {
        let payload = {
          allModuleId: this.goodReceived.allModuleId,
          containerNo: this.goodReceived.containerNo,
          itemCode: "CheckContainerNumber",
          type: "Check",
        };

        this.timmerMsg = "Please Wait - Searching Container Number";

        setTimeout(() => {
          CommonService.getCheckBLDetails(payload)
            .then((response) => {
              const { data, status, statusText } = response;
              if (data.FLAG != "" && data.FLAG != undefined) {
                this.timmerMsg = data.MSG;
                this.checkContNoButton = data.FLAG;
              } else {
                // this.alert.content = data.MSG;
              }
              this.isLoading = false;
            })

            .catch((error) => {
              console.log("Catch on getDatacheck - CheckCOntainerNumber Error: ", error);
            });
        }, 2000);
      }
    },
    refuelAddress1(item) {
      this.goodReceived.refuelAddress = item.vendorAddress;
      this.goodReceived.reFuelstation = item.refuelStationId;
      this.goodReceived.vendorName = item.vendorName;
      this.goodReceived.refuelContact = item.contactNumber;
    },
    getData1() {
      this.doLoading();
      this.assignmentContainersList = [];
      let new_data = {
        salesBookingId: this.$sessionsStorage.get("salesBookingId"),
        clientId: this.$sessionsStorage.get("clientId"),
        quotationId: this.$sessionsStorage.get("storeQuotationId"),
        assignId: this.$sessionsStorage.get("storeAssignId"),
      };

      let currentDate = new Date();
      let options = {
        method: "POST",
        url: `${URL_BASE}/Api_Transport/viewGenerateGrn_NewV3.php`,

        data: JSON.stringify(new_data),

        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId"),
        },
      };
      axios(options)
        .then((result) => {
          const { statusText, status, data } = result;
          if (result && data && status == 200) {
            this.allData = data;
            console.log(data, "uy");
            let CONID = [];
            let CONTYPE = [];
            let NOCON = [];
            console.log("Priyanshu Singh=>", data);

            if (data.assignmentContainersList.length > 0) {
              this.assignmentContainersList = data.assignmentContainersList;
            }
            if (data.containerTypeArray.length > 0) {
              Object.keys(data.containerTypeArray[0]).map((x) => {
                if (x == "containerTypeId") {
                  if (data.containerTypeArray[0][x] != "") {
                    CONID = data.containerTypeArray[0][x].split(",") || [];
                  } else {
                    CONID = [];
                  }
                } else if (x == "containerType") {
                  if (data.containerTypeArray[0][x] != "") {
                    CONTYPE = data.containerTypeArray[0][x].split(",") || [];
                  } else {
                    CONTYPE = [];
                  }
                } else if (x == "noOfContainers") {
                  if (data.containerTypeArray[0][x] != null) {
                    NOCON = data.containerTypeArray[0][x].split(",") || [];
                  } else {
                    NOCON = [];
                  }
                } else {
                  CONID = [];
                  CONTYPE = [];
                  NOCON = [];
                }
              });

              this.containerCount = [];
              if (CONID.length > 0) {
                CONID.map((p, index) => {
                  let obj = {
                    containerTypeID: p,
                    Container_Type: CONTYPE[index],
                    noOfContainer: NOCON[index],
                  };

                  this.containerCount.push(obj);
                });
              }

              let CCCONTAINERDET = "";
              if (data.ccContainerDetails.length > 0) {
                CCCONTAINERDET =
                  " / Containers No :--" + data.ccContainerDetails[0].ContainerNo;
              }
              this.goodReceived.containerQuantity =
                "Container Type :-- " +
                data.containerTypeArray[0].containerType +
                " / No. of Containers :-- " +
                data.containerTypeArray[0].noOfContainers +
                CCCONTAINERDET;
            }

            if (data.refuelStationArray.length > 0) {
              this.refuelStationArr = data.refuelStationArray;
            }

            if (
              this.$sessionsStorage.get("clientId") != "" ||
              this.$sessionsStorage.get("clientId") != null
            ) {
              this.goodReceived.Date = this.formatDate(currentDate);
            }

            if (data.vehicleBookingList.length > 0) {
              this.vehicleBooking.allModuleId = data.vehicleBookingList[0].allModuleId;
              this.vehicleBooking.bookingNo = data.vehicleBookingList[0].bookingNo;
              this.vehicleBooking.assignSeries = data.vehicleBookingList[0].assignSeries;
              this.vehicleBooking.newContainerFlow =
                data.vehicleBookingList[0].newContainerFlow;
              this.vehicleBooking.noOfTrucks = data.vehicleBookingList[0].noOfTrucks;
              this.vehicleBooking.shipperCustomerName =
                data.vehicleBookingList[0].shippingCustomerName;
              this.vehicleBooking.pickupLocation =
                data.vehicleBookingList[0].fromLocation;
              this.vehicleBooking.destination = data.vehicleBookingList[0].toLocation;
              this.vehicleBooking.pickupLocation =
                data.vehicleBookingList[0].fromLocation;
              this.vehicleBooking.pickupLocation =
                data.vehicleBookingList[0].fromLocation;
              this.vehicleArray = data.vehicleBookingList[0].dummyVehicle;
            }

            if (data.goodReceivedArray.length > 0) {
              this.showGRNList = data.goodReceivedArray;
              this.goodReceived.reFuelstation = data.goodReceivedArray[0].refuelStation;

              this.refuelData = this.refuelStationArr.filter((x) => {
                return x.refuelStationId == data.goodReceivedArray[0].refuelStation;
              })[0];

              this.goodReceived.refuelAddress = data.goodReceivedArray[0].refuelAddress;
            } else {
              if (data.DieselInLtrDetails.length > 0) {
                this.goodReceived.advanceCash = data.DieselInLtrDetails[0].advanceCash;
              }
              if (
                data.DieselInLtrDetails.length > 0 &&
                this.goodReceived.tptType == "1"
              ) {
                if (data.QuotDieselInLtrDetails.length > 0) {
                  this.goodReceived.advanceCash =
                    data.QuotDieselInLtrDetails[0].advanceCash;
                  this.goodReceived.diesel = data.QuotDieselInLtrDetails[0].dieselRate;
                  console.log(
                    data.QuotDieselInLtrDetails[0].dieselRate,
                    "ioioi",
                    this.goodReceived.diesel
                  );
                  this.goodReceived.tollInCash = data.QuotDieselInLtrDetails[0].tollPrice;

                  this.dieselInLiters = parseFloat(
                    data.QuotDieselInLtrDetails[0].distance /
                      parseFloat(data.QuotDieselInLtrDetails[0].truckAverage)
                  ).toFixed(2);
                } else {
                  this.goodReceived.diesel = data.DieselInLtrDetails[0].dieselRate;
                  console.log(
                    data.DieselInLtrDetails[0].dieselRate,
                    "ioioi",
                    this.goodReceived.diesel
                  );
                  this.goodReceived.tollInCash = data.DieselInLtrDetails[0].tollPrice;

                  this.dieselInLiters = parseFloat(
                    data.DieselInLtrDetails[0].distance /
                      parseFloat(data.DieselInLtrDetails[0].truckAverage)
                  ).toFixed(2);
                }
              } else {
                this.goodReceived.dieselPrice = 0;
                this.goodReceived.tollInCash = 0;
                this.dieselInLiters = 0;
              }
              if (this.goodReceived.tptType == "1") {
                this.goodReceived.tollCard = 0;
              } else {
                this.goodReceived.diesel = 0;
                this.goodReceived.tollCard = 0;
                this.goodReceived.cashDeiselPaid = 0;
                this.goodReceived.otherCashExpenses = 0;
              }
            }

            if (data.followUplist.length > 0) {
              Object.keys(this.followActivityList).map((x) => {
                this.followActivityList[x] = data.followUplist[0][x] || "";
              });
            }
            if (data.vehicleDetailGrn.length > 0) {
              this.grnVehicleList = data.vehicleDetailGrn;
            }
            if (data.SalesBookingDetails.length > 0) {
              this.BOEDetails = data.SalesBookingDetails[0].type;

              this.goodReceived.allModuleId = data.SalesBookingDetails[0].allModuleId;
              this.goodReceived.NewContainerType =
                data.SalesBookingDetails[0].multipleContainerType;
              this.goodReceived.NewContainerTypeId =
                data.SalesBookingDetails[0].multipleContainerTypeId;
              this.goodReceived.containerInfo = data.SalesBookingDetails[0].containerInfo;
              this.goodReceived.shipmentType = data.SalesBookingDetails[0].shipmentType;
              this.goodReceived.jobType = data.SalesBookingDetails[0].jobType;
              this.goodReceived.coLoaderId = data.SalesBookingDetails[0].coLoaderId;
              this.goodReceived.transportType = data.SalesBookingDetails[0].transportType;
              if (this.goodReceived.jobType.indexOf("FF") >= 0) {
                this.goodReceived.commodityType =
                  data.SalesBookingDetails[0].commodityType.indexOf("Hazardous") >= 0
                    ? "HAZ"
                    : "";
              } else {
                this.goodReceived.commodityType = "";
              }
              this.goodReceived.PODLocation = data.SalesBookingDetails[0].PODLocation;
              this.goodReceived.salesSeries = data.SalesBookingDetails[0].salesSeries.replaceAll(
                "/",
                "_"
              );
            }
            this.vehicleTypeList = data.vehicleType;
            if (data.slineDetails.length > 0) {
              this.getShipping = data.slineDetails;
            }
            if (data.execContainerData.length > 0) {
              this.getContainertype = data.execContainerData;

              if (data.goodReceivedArrayAll.length > 0) {
                let addedConArry = [];

                for (let r = 0; r < this.getContainertype.length; r++) {
                  let arryCount = data.goodReceivedArrayAll.filter((x) => {
                    return x == this.getContainertype[r].containerTypeId;
                  });
                  let arryCountNe = this.containerCount.filter((x) => {
                    return x.containerTypeID == this.getContainertype[r].containerTypeId;
                  });
                  if (arryCount.length > 0 && arryCountNe.length > 0) {
                    if (arryCount.length == parseInt(arryCountNe[0].noOfContainer)) {
                      this.getContainertype.splice(r, 1);
                    }
                  }
                }
              }
            }
            if (data.assignedDriverData.length > 0) {
              this.assignedDriverAll = data.assignedDriverData;
            } else {
              this.assignedDriverAll = [];
            }
            this.dummyFuelSlip = data.FuelSlipNo;
            if (this.goodReceived.tptType == "1") {
              this.goodReceived.FuelSlipNo = data.FuelSlipNo;
              this.goodReceived.skipGRN = "0";
            } else {
              this.goodReceived.FuelSlipNo = "";
              this.goodReceived.skipGRN = "1";
            }

            if (data.DieselInLtrDetails.length > 0) {
              if (data.QuotDieselInLtrDetails.length > 0) {
                this.goodReceived.advanceCash =
                  data.QuotDieselInLtrDetails[0].advanceCash;
                this.goodReceived.diesel = data.QuotDieselInLtrDetails[0].dieselRate;
              } else {
                this.goodReceived.advanceCash = data.DieselInLtrDetails[0].advanceCash;
              }
            }

            this.finalActivityCost();
            if (
              this.goodReceived.shipmentType == "1" &&
              this.goodReceived.NewContainerTypeId.indexOf("15") >= 0 &&
              this.goodReceived.transportType == "Export" &&
              this.goodReceived.containerInfo == "lcl" &&
              this.goodReceived.containerNo == ""
            ) {
              this.goodReceived.containerNo = "LCL CONTAINER";
            }
            this.doLoadingClose();
          }
        })
        .catch((error) => {});
    },
  },
};
</script>
<style>
.md-direction-bottom-right {
  width: 22% !important;
}
.mrgtop-2per {
  margin-top: 2%;
}

.margTop-Booking {
  margin-top: 2%;
}
.mrgtop-5px {
  margin-top: 5px;
}
.center {
  text-align: center;
}
.heght-1px {
  height: 1px;
}

.b-form-input-container {
  margin: 4px 0 5px !important;
}
.md-button-color {
  background-color: #607d8d !important;
  height: 10px;
}

.md-button-color-toggle {
  background-color: rgba(153, 153, 153, 0.4) !important;
}

.activeClass {
  display: none;
}
.error {
  color: red;
}
.md-dialog-container {
  z-index: 999999 !important;
}
</style>



// WEBPACK FOOTER //
// vehicleBooking.vue?535a9bde